import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AddDraftToCartInput = {
  /** Draft Id */
  id: Scalars['String']['input'];
  /** Parent Id */
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type AddItemToCartInput = {
  /** Will the item be customized? */
  isCustomized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent ID of item for the checkout. */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** PortfolioItem to create and associate */
  portfolioItem?: InputMaybe<PortfolioItemInput>;
  /** Quantity of item for the checkout. */
  quantity: Scalars['Int']['input'];
  /** Fields to track parent order information for reorders */
  reorderAttributes?: InputMaybe<ReorderAttributesInput>;
  /** Variation id. */
  variationId: Scalars['String']['input'];
};

export type AddItemToOrderInput = {
  /** Id of order to target */
  orderId: Scalars['Int']['input'];
  /** Quantity of item */
  quantity: Scalars['Int']['input'];
  /** Variation Id of item to add to order */
  variationId: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  /** The city of the recipient. */
  city: Scalars['String']['output'];
  /** The country of the recipient. */
  country: Scalars['String']['output'];
  /** The first name of the recipient. */
  firstName: Scalars['String']['output'];
  /** The last name of the recipient. */
  lastName: Scalars['String']['output'];
  /** The phone number associated with the address. */
  phone: Scalars['String']['output'];
  /** The state of the recipient. */
  state: Scalars['String']['output'];
  /** The street address line 1 of the recipient. */
  street: Scalars['String']['output'];
  /** The street address line 2 of the recipient. */
  street2: Scalars['String']['output'];
  /** The zip code of the recipient. */
  zipCode: Scalars['String']['output'];
};

export type ApplyCouponDetailedResult = {
  __typename?: 'ApplyCouponDetailedResult';
  /** Array of applied coupons with details. */
  coupons?: Maybe<Array<Coupon>>;
  /** Store cart Id code. */
  storeCartId?: Maybe<Scalars['String']['output']>;
};

export type BannerCollection = {
  __typename?: 'BannerCollection';
  items: Array<BannerGraphqlModel>;
  pagination: PaginationData;
};

export type BannerCollectionResolver_GetBannerCollection_BaseFilterInputType = {
  and?: InputMaybe<Array<BannerCollectionResolver_GetBannerCollection_BaseFilterInputType>>;
  backgroundColor?: InputMaybe<String_PropertyFilterInputType>;
  backgroundImageUrl?: InputMaybe<String_PropertyFilterInputType>;
  bannerLink?: InputMaybe<String_PropertyFilterInputType>;
  buttonLink?: InputMaybe<String_PropertyFilterInputType>;
  buttonText?: InputMaybe<String_PropertyFilterInputType>;
  createdAt?: InputMaybe<Date_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  justifyText?: InputMaybe<String_PropertyFilterInputType>;
  location?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<BannerCollectionResolver_GetBannerCollection_BaseFilterInputType>>;
  order?: InputMaybe<Number_PropertyFilterInputType>;
  page?: InputMaybe<String_PropertyFilterInputType>;
  priority?: InputMaybe<Number_PropertyFilterInputType>;
  publishedAt?: InputMaybe<Date_PropertyFilterInputType>;
  routes?: InputMaybe<String_PropertyFilterInputType>;
  template?: InputMaybe<String_PropertyFilterInputType>;
  tenant?: InputMaybe<String_PropertyFilterInputType>;
  title?: InputMaybe<String_PropertyFilterInputType>;
  updatedAt?: InputMaybe<Date_PropertyFilterInputType>;
};

export type BannerCollectionResolver_GetBannerCollection_FilterInputType = {
  and?: InputMaybe<Array<BannerCollectionResolver_GetBannerCollection_BaseFilterInputType>>;
  backgroundColor?: InputMaybe<String_PropertyFilterInputType>;
  backgroundImageUrl?: InputMaybe<String_PropertyFilterInputType>;
  bannerLink?: InputMaybe<String_PropertyFilterInputType>;
  buttonLink?: InputMaybe<String_PropertyFilterInputType>;
  buttonText?: InputMaybe<String_PropertyFilterInputType>;
  createdAt?: InputMaybe<Date_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  justifyText?: InputMaybe<String_PropertyFilterInputType>;
  location?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<BannerCollectionResolver_GetBannerCollection_BaseFilterInputType>>;
  order?: InputMaybe<Number_PropertyFilterInputType>;
  page?: InputMaybe<String_PropertyFilterInputType>;
  priority?: InputMaybe<Number_PropertyFilterInputType>;
  publishedAt?: InputMaybe<Date_PropertyFilterInputType>;
  routes?: InputMaybe<String_PropertyFilterInputType>;
  template?: InputMaybe<String_PropertyFilterInputType>;
  tenant?: InputMaybe<String_PropertyFilterInputType>;
  title?: InputMaybe<String_PropertyFilterInputType>;
  updatedAt?: InputMaybe<Date_PropertyFilterInputType>;
};

export type BannerCollectionResolver_GetBannerCollection_SortingInputType = {
  backgroundColor?: InputMaybe<SortType>;
  backgroundImageUrl?: InputMaybe<SortType>;
  bannerLink?: InputMaybe<SortType>;
  buttonLink?: InputMaybe<SortType>;
  buttonText?: InputMaybe<SortType>;
  createdAt?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  justifyText?: InputMaybe<SortType>;
  location?: InputMaybe<SortType>;
  order?: InputMaybe<SortType>;
  page?: InputMaybe<SortType>;
  priority?: InputMaybe<SortType>;
  publishedAt?: InputMaybe<SortType>;
  routes?: InputMaybe<SortType>;
  template?: InputMaybe<SortType>;
  tenant?: InputMaybe<SortType>;
  title?: InputMaybe<SortType>;
  updatedAt?: InputMaybe<SortType>;
};

export type BannerGraphqlModel = {
  __typename?: 'BannerGraphqlModel';
  /** Background color */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Background Image Url */
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  /** Link of the banner */
  bannerLink?: Maybe<Scalars['String']['output']>;
  /** Button link */
  buttonLink?: Maybe<Scalars['String']['output']>;
  /** Call To action text */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Creation date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Desktop Image */
  frontImageDesktop?: Maybe<BannerImageGraphql>;
  /** Mobile Image */
  frontImageMobile?: Maybe<BannerImageGraphql>;
  /** Id of banner */
  id: Scalars['String']['output'];
  /** Text Alignment property */
  justifyText?: Maybe<Scalars['String']['output']>;
  /** Position within the UI */
  location?: Maybe<Scalars['String']['output']>;
  /** Order */
  order?: Maybe<Scalars['Float']['output']>;
  /** Page banner location */
  page?: Maybe<Scalars['String']['output']>;
  /** Sorting Priority */
  priority?: Maybe<Scalars['Float']['output']>;
  /** Promotion */
  promotion?: Maybe<BannerPromotionGraphql>;
  /** Published date */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Routes where the banner is available */
  routes?: Maybe<Array<Scalars['String']['output']>>;
  /** Banner template type */
  template?: Maybe<Scalars['String']['output']>;
  /** tenant */
  tenant: Scalars['String']['output'];
  /** Rich Text JSON like Object */
  text?: Maybe<BannerTextGraphql>;
  /** Main Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Update date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BannerImageGraphql = {
  __typename?: 'BannerImageGraphql';
  /** Height of image */
  height?: Maybe<Scalars['Float']['output']>;
  /** Title of image */
  title?: Maybe<Scalars['String']['output']>;
  /** Url of image */
  url?: Maybe<Scalars['String']['output']>;
  /** Width of image */
  width?: Maybe<Scalars['Float']['output']>;
};

export type BannerJsonDataGraphql = {
  __typename?: 'BannerJsonDataGraphql';
  /** Content of json */
  content?: Maybe<Array<BannerJsonDataGraphql>>;
  /** Type of node */
  nodeType?: Maybe<Scalars['String']['output']>;
  /** Value of json */
  value?: Maybe<Scalars['String']['output']>;
};

export type BannerPromotionGraphql = {
  __typename?: 'BannerPromotionGraphql';
  /** Id of promotion */
  id?: Maybe<Scalars['String']['output']>;
  /** Name of promotion */
  name?: Maybe<Scalars['String']['output']>;
};

export type BannerTextGraphql = {
  __typename?: 'BannerTextGraphql';
  /** Title of image */
  json?: Maybe<BannerJsonDataGraphql>;
  /** Url of image */
  links?: Maybe<BannerTextLinkGraphql>;
};

export type BannerTextLinkGraphql = {
  __typename?: 'BannerTextLinkGraphql';
  /** Content type of link */
  contentType?: Maybe<Scalars['String']['output']>;
  /** Description of link */
  description?: Maybe<Scalars['String']['output']>;
  /** Height of link */
  height?: Maybe<Scalars['Float']['output']>;
  /** Id of link */
  id?: Maybe<Scalars['String']['output']>;
  /** Title of link */
  title?: Maybe<Scalars['String']['output']>;
  /** Url of link */
  url?: Maybe<Scalars['String']['output']>;
  /** Width of link */
  width?: Maybe<Scalars['Float']['output']>;
};

export type Boolean_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
  notbetween?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BubbleComponentGraphqlModel = {
  __typename?: 'BubbleComponentGraphqlModel';
  /** Bubble collection of the bubble component */
  bubbleCollection: Array<BubbleLinkGraphqlModel>;
  /** Display of the bubble component */
  display: Scalars['String']['output'];
  /** Id of the bubble component */
  externalId: Scalars['String']['output'];
  /** Title of the bubble component */
  title: Scalars['String']['output'];
};

export type BubbleLinkGraphqlModel = {
  __typename?: 'BubbleLinkGraphqlModel';
  /** Image url of the bubble link */
  imageUrl: Scalars['String']['output'];
  /** Title of the bubble link */
  title: Scalars['String']['output'];
  /** Url of the bubble link */
  url: Scalars['String']['output'];
};

export type BulkPrice = {
  __typename?: 'BulkPrice';
  /**
   * Bulk Price top quantity limit price
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  amount: Scalars['Float']['output'];
  /**
   * Bulk Price top quantity limit
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  quantity: Scalars['Float']['output'];
};

export type Canvas = {
  __typename?: 'Canvas';
  /** Configuration for initializing a variation-based customization. */
  canvasInitialization?: Maybe<CanvasInitialization>;
  canvasInitializationByProduct?: Maybe<CanvasInitializationByProduct>;
  /** Portfolio Item */
  portfolioItem: PortfolioItem;
  /**
   * Portfolio Item ID
   * @deprecated Use portfolioItem.id instead
   */
  portfolioItemId: Scalars['String']['output'];
  /** Product suite data for breadcrumb */
  productSuite: Suite;
  /** CC user id */
  userId: Scalars['String']['output'];
};

export type CanvasConfigurationInput = {
  /** Id corresponding to the product variation */
  variationId: Scalars['UUID']['input'];
};

export type CanvasInitialization = {
  __typename?: 'CanvasInitialization';
  /**
   * Path for the back side of the customizer design file for a product variation.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  back?: Maybe<Scalars['String']['output']>;
  /**
   * Path for the front side of the customizer design file for a product variation.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  front?: Maybe<Scalars['String']['output']>;
  /**
   * Path for the mockup customizer design file used by a foil product variation
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  mockup?: Maybe<Scalars['String']['output']>;
  /** CC initialization safety lines */
  safetyLines: Array<CanvasSafetyLine>;
};

export type CanvasInitializationByProduct = {
  __typename?: 'CanvasInitializationByProduct';
  /** Colors to use in the template for each color theme */
  colorPalettes?: Maybe<Scalars['JSONObject']['output']>;
  /** Configuration for the template */
  config?: Maybe<TemplateConfiguration>;
  /** Design file path for the product */
  designFile?: Maybe<Scalars['String']['output']>;
  /** Names of the layers in the design file for each option value */
  layerIds?: Maybe<Scalars['JSONObject']['output']>;
  /** CC initialization safety lines */
  safetyLines: Array<CanvasSafetyLine>;
};

export type CanvasMutation = {
  __typename?: 'CanvasMutation';
  initCanvas: InitCanvasResult;
};


export type CanvasMutationInitCanvasArgs = {
  input: InitCanvasInput;
};

export type CanvasQuery = {
  __typename?: 'CanvasQuery';
  findOneByPortfolio?: Maybe<Canvas>;
  findOneByVariation: VariationCanvas;
};


export type CanvasQueryFindOneByPortfolioArgs = {
  portfolioItemId: Scalars['String']['input'];
};


export type CanvasQueryFindOneByVariationArgs = {
  input: CanvasConfigurationInput;
};

export type CanvasSafetyLine = {
  __typename?: 'CanvasSafetyLine';
  /** altColor of safety line object */
  altColor?: Maybe<Scalars['String']['output']>;
  /** border radius of safety line object */
  borderRadius?: Maybe<Scalars['Int']['output']>;
  /** color of safety line object */
  color: Scalars['String']['output'];
  /** margin of safety line object */
  margin?: Maybe<Scalars['Int']['output']>;
  /** stepPx of safety line object */
  stepPx?: Maybe<Scalars['Int']['output']>;
  /** widthPx of safety line object */
  widthPx?: Maybe<Scalars['Int']['output']>;
};

export type CartDetails = {
  __typename?: 'CartDetails';
  /** The total cart amount after discounts. */
  cartAmount: Scalars['Float']['output'];
  /** Coupons applied to the cart. */
  coupons: Array<Coupon>;
  /** Currency code. */
  currencyCode: Scalars['String']['output'];
  /** Discount applied to the cart. */
  discountAmount: Scalars['Float']['output'];
  /** Items in cart. */
  items: Array<CartDetailsItem>;
  /** Store cart Id code. */
  storeCartId: Scalars['String']['output'];
  /** Cart total amount. */
  totalAmount: Scalars['Float']['output'];
};

export type CartDetailsItem = {
  __typename?: 'CartDetailsItem';
  accessories?: Maybe<ItemAccessories>;
  /** Id of the product in the catalog. */
  catalogProductId: Scalars['String']['output'];
  /** Name of the Collection in the catalog for the product. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /**
   * Color theme name that matches the cart item.
   * @deprecated Use variation.optionValues instead
   */
  colorThemeName?: Maybe<Scalars['String']['output']>;
  /** Partnership of product offering. */
  designedBy?: Maybe<Scalars['String']['output']>;
  displayVariation?: Maybe<CatalogProductVariationGraphqlModel>;
  /**
   * Envelope printing name that matches the cart item.
   * @deprecated Use variation.optionValues instead
   */
  envelopePrintingName?: Maybe<Scalars['String']['output']>;
  /**
   * Foil theme name that matches the cart item.
   * @deprecated Use variation.optionValues instead
   */
  foilThemeName?: Maybe<Scalars['String']['output']>;
  /** Id of the cart item. */
  id: Scalars['String']['output'];
  /**
   * Paper type name that matches the cart item.
   * @deprecated Use variation.optionValues instead
   */
  paperTypeName?: Maybe<Scalars['String']['output']>;
  /** Identifier for the parent item in case of bundled items. */
  parentId?: Maybe<Scalars['String']['output']>;
  portfolioItem?: Maybe<PortfolioItem>;
  price?: Maybe<VariationPrice>;
  /** Name of the product. */
  productName: Scalars['String']['output'];
  /** Merchandising photos of the product variation. */
  productPhotos: ProductPhotos;
  /** Name of the product type, like "Wedding Invitations." */
  productTypeName: Scalars['String']['output'];
  /** Quantity of item for the cart. */
  quantity: Scalars['Float']['output'];
  related?: Maybe<RelatedVariations>;
  /** Url path to the product. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Item total amount. */
  totalAmount: Scalars['Float']['output'];
  /** @deprecated Use displayVariation instead. */
  variation?: Maybe<Variation>;
};

export type CartIdResult = {
  __typename?: 'CartIdResult';
  /** Store cart Id code. */
  storeCartId?: Maybe<Scalars['String']['output']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  /** Id of the product in the CMS. */
  catalogProductId: Scalars['String']['output'];
  /** Identifier for the parent item in case of bundled items. */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Id of the portfolio item. */
  portfolioItemId: Scalars['String']['output'];
  /** Quantity of item for the cart. */
  quantity: Scalars['Int']['output'];
  /** Id of the cart item in the store. */
  storeItemId: Scalars['String']['output'];
  /** Variation id. */
  variationId: Scalars['String']['output'];
};

export type CartMutation = {
  __typename?: 'CartMutation';
  addItem?: Maybe<SingleItemCartResult>;
  applyCoupon?: Maybe<ApplyCouponDetailedResult>;
  applyCoupons?: Maybe<CartIdResult>;
  removeCoupon?: Maybe<CartIdResult>;
  removeItems?: Maybe<CartResult>;
  updateItems?: Maybe<MultiItemCartResult>;
};


export type CartMutationAddItemArgs = {
  input: AddItemToCartInput;
};


export type CartMutationApplyCouponArgs = {
  couponCode: Scalars['String']['input'];
};


export type CartMutationRemoveCouponArgs = {
  couponCode: Scalars['String']['input'];
};


export type CartMutationRemoveItemsArgs = {
  input: RemoveFromCartInput;
};


export type CartMutationUpdateItemsArgs = {
  input: UpdateCartItemInput;
};

export type CartQuery = {
  __typename?: 'CartQuery';
  details?: Maybe<CartDetails>;
  itemCount: Scalars['Int']['output'];
};

export type CartResult = {
  __typename?: 'CartResult';
  /** Updated cart */
  cart?: Maybe<CartDetails>;
};

export type CatalogDesignEditorMarkupGraphqlModel = {
  __typename?: 'CatalogDesignEditorMarkupGraphqlModel';
  /** The fold lines of the catalog product type */
  foldLines?: Maybe<Array<CatalogFoldLineGraphqlModel>>;
  /** The design editor mockup files */
  mockupFiles?: Maybe<Array<CatalogDesignEditorMockupFileGraphqlModel>>;
  /** The orientation of the catalog product type */
  orientation: Scalars['String']['output'];
  /** The product options of the catalog product type */
  productOptions?: Maybe<Array<CatalogDesignEditorMarkupProductOptionGraphqlModel>>;
  /** The spine lines of the catalog product type */
  spineLines?: Maybe<Array<CatalogSpineLineGraphqlModel>>;
  /** The texture files of the catalog product type */
  textureFiles?: Maybe<Array<CatalogDesignEditorTextureFileGraphqlModel>>;
};

export type CatalogDesignEditorMarkupProductOptionGraphqlModel = {
  __typename?: 'CatalogDesignEditorMarkupProductOptionGraphqlModel';
  /** The code of the product option */
  code?: Maybe<Scalars['String']['output']>;
  /** The option type code of the product option */
  optionTypeCode?: Maybe<Scalars['String']['output']>;
};

export type CatalogDesignEditorMockupFileGraphqlModel = {
  __typename?: 'CatalogDesignEditorMockupFileGraphqlModel';
  /** The file path of the mockup file */
  filePath: Scalars['String']['output'];
  /** Is the cut area enabled for this mockup file */
  isCutAreaEnabled: Scalars['Boolean']['output'];
  /** If the mockup file is a substrate */
  isSubstrate: Scalars['Boolean']['output'];
  /** The mockup context of the mockup file */
  mockupContext: Scalars['String']['output'];
  /** The surface of the mockup file */
  surface: Scalars['String']['output'];
};

export type CatalogDesignEditorTextureFileGraphqlModel = {
  __typename?: 'CatalogDesignEditorTextureFileGraphqlModel';
  /** The file path of the texture file */
  filePath: Scalars['String']['output'];
};

export type CatalogDraftsGraphqlModel = {
  __typename?: 'CatalogDraftsGraphqlModel';
  /** Group id of the draft */
  draftGroupId: Scalars['String']['output'];
  /** Id of the draft */
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  /** Parent item id of the draft */
  parentItemId?: Maybe<Scalars['String']['output']>;
  portfolioItem: PortfolioItem;
  /** Id of the porfolio item */
  portfolioItemId: PortfolioItem;
  price: Scalars['Float']['output'];
  /** Selected quantity product */
  quantity: Scalars['Float']['output'];
  /** Tenant of the draft */
  tenant: Scalars['String']['output'];
  /** Last update */
  updatedAt: Scalars['DateTime']['output'];
  /** Member id of the draft */
  userId: Scalars['String']['output'];
  variation: CatalogProductVariationGraphqlModel;
};

export type CatalogFoldLineGraphqlModel = {
  __typename?: 'CatalogFoldLineGraphqlModel';
  /** The bleed of the fold line */
  bleed?: Maybe<Scalars['Float']['output']>;
  /** If the fold line is vertical */
  isVertical: Scalars['Boolean']['output'];
  /** The margin of the fold line */
  margin?: Maybe<Scalars['String']['output']>;
  /** The pen of the fold line */
  pen?: Maybe<CatalogFoldLinePenGraphqlModel>;
};

export type CatalogFoldLinePenGraphqlModel = {
  __typename?: 'CatalogFoldLinePenGraphqlModel';
  /** The color of the pen */
  color?: Maybe<Scalars['String']['output']>;
  /** The dash step of the pen */
  dashStep?: Maybe<Scalars['Float']['output']>;
  /** The width of the pen */
  width?: Maybe<Scalars['Float']['output']>;
};

export type CatalogProductCategoryGraphqlModel = {
  __typename?: 'CatalogProductCategoryGraphqlModel';
  /** Id of the product category */
  externalId: Scalars['String']['output'];
  /** Name of the product category */
  name: Scalars['String']['output'];
  /** Slug of the product category */
  slug: Scalars['String']['output'];
};

export type CatalogProductCollectionCollection = {
  __typename?: 'CatalogProductCollectionCollection';
  items: Array<CatalogProductCollectionGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_BaseFilterInputType = {
  and?: InputMaybe<Array<CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  color?: InputMaybe<String_PropertyFilterInputType>;
  designNoteImageUrl?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  imageUrl?: InputMaybe<String_PropertyFilterInputType>;
  isInBadge?: InputMaybe<Boolean_PropertyFilterInputType>;
  isInBreadcrumbs?: InputMaybe<Boolean_PropertyFilterInputType>;
  isInMatchingSuites?: InputMaybe<Boolean_PropertyFilterInputType>;
  isInTitle?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_BaseFilterInputType>>;
  restrictedCustomerCanvasOption?: InputMaybe<Boolean_PropertyFilterInputType>;
  slug?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_FilterInputType = {
  and?: InputMaybe<Array<CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  color?: InputMaybe<String_PropertyFilterInputType>;
  designNoteImageUrl?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  imageUrl?: InputMaybe<String_PropertyFilterInputType>;
  isInBadge?: InputMaybe<Boolean_PropertyFilterInputType>;
  isInBreadcrumbs?: InputMaybe<Boolean_PropertyFilterInputType>;
  isInMatchingSuites?: InputMaybe<Boolean_PropertyFilterInputType>;
  isInTitle?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_BaseFilterInputType>>;
  restrictedCustomerCanvasOption?: InputMaybe<Boolean_PropertyFilterInputType>;
  slug?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_SortingInputType = {
  code?: InputMaybe<SortType>;
  color?: InputMaybe<SortType>;
  designNoteImageUrl?: InputMaybe<SortType>;
  externalId?: InputMaybe<SortType>;
  imageUrl?: InputMaybe<SortType>;
  isInBadge?: InputMaybe<SortType>;
  isInBreadcrumbs?: InputMaybe<SortType>;
  isInMatchingSuites?: InputMaybe<SortType>;
  isInTitle?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  restrictedCustomerCanvasOption?: InputMaybe<SortType>;
  slug?: InputMaybe<SortType>;
};

export type CatalogProductCollectionFindOneByCodeInput = {
  /** string */
  code: Scalars['String']['input'];
};

export type CatalogProductCollectionGraphqlModel = {
  __typename?: 'CatalogProductCollectionGraphqlModel';
  /** Collection Code */
  code: Scalars['String']['output'];
  /** Collection Color */
  color: Scalars['String']['output'];
  /** Collection design notes url */
  designNoteImageUrl: Scalars['String']['output'];
  /** Collection Name */
  externalId: Scalars['String']['output'];
  /** Collection Image Url */
  imageUrl: Scalars['String']['output'];
  /** Determine if Collection shows in the Badge */
  isInBadge: Scalars['Boolean']['output'];
  /** Determine if Collection shows in the Breadcrumbs */
  isInBreadcrumbs: Scalars['Boolean']['output'];
  /** Determine if Collection shows in the Matching Suites section */
  isInMatchingSuites: Scalars['Boolean']['output'];
  /** Determine if Collection shows in the Title */
  isInTitle: Scalars['Boolean']['output'];
  /** Collection Name */
  name: Scalars['String']['output'];
  /** Determine if Collection is Restricted Customer Canvas Option */
  restrictedCustomerCanvasOption: Scalars['Boolean']['output'];
  /** Collection Slug */
  slug: Scalars['String']['output'];
};

export type CatalogProductCollectionQuery = {
  __typename?: 'CatalogProductCollectionQuery';
  findOneByCode: CatalogProductCollectionGraphqlModel;
};


export type CatalogProductCollectionQueryFindOneByCodeArgs = {
  input: CatalogProductCollectionFindOneByCodeInput;
};

export type CatalogProductDisplayVariationInput = {
  /**
   * Used to match the variation that matches most of the product option values.
   * When Provided for Related Formats or Matching Suites (level 1) you can provide the Parent Product Variation ID, and its
   * Option values will be used for the lookup instead.
   */
  optionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Variations that are match, SHOULD contain the provided option values */
  requiredOptionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Used to match the variation by product option values */
  variationId?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogProductDraftCollection = {
  __typename?: 'CatalogProductDraftCollection';
  items: Array<CatalogDraftsGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductDraftCollectionResolver_GetDraftCollection_BaseFilterInputType = {
  and?: InputMaybe<Array<CatalogProductDraftCollectionResolver_GetDraftCollection_BaseFilterInputType>>;
  draftGroupId?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  image?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductDraftCollectionResolver_GetDraftCollection_BaseFilterInputType>>;
  parentItemId?: InputMaybe<String_PropertyFilterInputType>;
  price?: InputMaybe<Number_PropertyFilterInputType>;
  quantity?: InputMaybe<Number_PropertyFilterInputType>;
  tenant?: InputMaybe<String_PropertyFilterInputType>;
  updatedAt?: InputMaybe<Date_PropertyFilterInputType>;
  userId?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType = {
  and?: InputMaybe<Array<CatalogProductDraftCollectionResolver_GetDraftCollection_BaseFilterInputType>>;
  draftGroupId?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  image?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductDraftCollectionResolver_GetDraftCollection_BaseFilterInputType>>;
  parentItemId?: InputMaybe<String_PropertyFilterInputType>;
  price?: InputMaybe<Number_PropertyFilterInputType>;
  quantity?: InputMaybe<Number_PropertyFilterInputType>;
  tenant?: InputMaybe<String_PropertyFilterInputType>;
  updatedAt?: InputMaybe<Date_PropertyFilterInputType>;
  userId?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType = {
  draftGroupId?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  image?: InputMaybe<SortType>;
  parentItemId?: InputMaybe<SortType>;
  price?: InputMaybe<SortType>;
  quantity?: InputMaybe<SortType>;
  tenant?: InputMaybe<SortType>;
  updatedAt?: InputMaybe<SortType>;
  userId?: InputMaybe<SortType>;
};

export type CatalogProductFormatCollection = {
  __typename?: 'CatalogProductFormatCollection';
  items: Array<CatalogProductFormatGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_BaseFilterInputType = {
  and?: InputMaybe<Array<CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  iconUrl?: InputMaybe<String_PropertyFilterInputType>;
  imageUrl?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_BaseFilterInputType>>;
  priceNotation?: InputMaybe<String_PropertyFilterInputType>;
  sizeLongText?: InputMaybe<String_PropertyFilterInputType>;
  sizeShortText?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_FilterInputType = {
  and?: InputMaybe<Array<CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  iconUrl?: InputMaybe<String_PropertyFilterInputType>;
  imageUrl?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_BaseFilterInputType>>;
  priceNotation?: InputMaybe<String_PropertyFilterInputType>;
  sizeLongText?: InputMaybe<String_PropertyFilterInputType>;
  sizeShortText?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_SortingInputType = {
  code?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  externalId?: InputMaybe<SortType>;
  iconUrl?: InputMaybe<SortType>;
  imageUrl?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  priceNotation?: InputMaybe<SortType>;
  sizeLongText?: InputMaybe<SortType>;
  sizeShortText?: InputMaybe<SortType>;
};

export type CatalogProductFormatGraphqlModel = {
  __typename?: 'CatalogProductFormatGraphqlModel';
  /** The code of the catalog product format */
  code: Scalars['String']['output'];
  /** The description of the catalog product format */
  description?: Maybe<Scalars['String']['output']>;
  /** The external id of the catalog product format */
  externalId: Scalars['String']['output'];
  /** The icon url of the catalog product format */
  iconUrl: Scalars['String']['output'];
  /** The image url of the catalog product format */
  imageUrl: Scalars['String']['output'];
  /** The name of the catalog product format */
  name: Scalars['String']['output'];
  /** The price of the catalog product format */
  priceNotation: Scalars['String']['output'];
  /** The long text for catalog product format size */
  sizeLongText: Scalars['String']['output'];
  /** The short text for catalog product format size */
  sizeShortText: Scalars['String']['output'];
};

export type CatalogProductGraphqlCollection = {
  __typename?: 'CatalogProductGraphqlCollection';
  items: Array<CatalogProductGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductGraphqlFindManyByAssetValuesInput = {
  /** Catalog Product Type Asset Product Alias */
  assetProductAlias: Scalars['String']['input'];
  /** Catalog Product Type Asset Product Code */
  assetProductCode: Scalars['String']['input'];
  /** Catalog Product Suite name */
  assetSuiteName: Scalars['String']['input'];
};

export type CatalogProductGraphqlFindManyInput = {
  /** External ID for the product */
  slugs: Array<Scalars['String']['input']>;
};

export type CatalogProductGraphqlFindOneInput = {
  /** External ID for the product */
  slug: Scalars['String']['input'];
};

export type CatalogProductGraphqlModel = {
  __typename?: 'CatalogProductGraphqlModel';
  /** Product option value codes that must be selected for samples of this product */
  allowedSampleCombinationCodes?: Maybe<Array<Array<Scalars['String']['output']>>>;
  /** The display variation of the product */
  catalogProductCategory?: Maybe<CatalogProductCategoryGraphqlModel>;
  catalogProductCollection?: Maybe<CatalogProductCollectionGraphqlModel>;
  /** The related collection code of the product/suite */
  catalogProductCollectionCode?: Maybe<Scalars['String']['output']>;
  catalogProductFormat?: Maybe<CatalogProductFormatGraphqlModel>;
  /** The format code of the product */
  catalogProductFormatCode: Scalars['String']['output'];
  catalogProductSuite: CatalogProductSuiteGraphqlModel;
  /** The suite code of the product */
  catalogProductSuiteCode: Scalars['String']['output'];
  catalogProductType: CatalogProductTypeGraphqlModel;
  /** The type code of the product */
  catalogProductTypeCode: Scalars['String']['output'];
  designEditorMarkup?: Maybe<CatalogDesignEditorMarkupGraphqlModel>;
  displayVariation: CatalogProductVariationGraphqlModel;
  /** The id of the catalog product */
  externalId: Scalars['ID']['output'];
  /** Product option value codes that cannot be combined for this product */
  forbiddenCombinationsCodes?: Maybe<Array<Array<Scalars['String']['output']>>>;
  /** Indicates if the product must only use Photoshop for customizations */
  forcePhotoshop?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if the product is live to customers */
  isLive?: Maybe<Scalars['Boolean']['output']>;
  /** Product Metadata */
  metadata?: Maybe<CatalogProductMetadataGraphqlModel>;
  /** The name of the catalog product */
  name: Scalars['String']['output'];
  /** The orientation of the catalog product */
  orientation: Scalars['String']['output'];
  /** Number of photos that the product design support */
  photos?: Maybe<Scalars['Float']['output']>;
  /** Used for search proposes, indicate the priority when listing products of same type */
  position?: Maybe<Scalars['Float']['output']>;
  recommendedVariations?: Maybe<Array<CatalogProductVariationGraphqlModel>>;
  /** The related format product type code of the product */
  relatedFormatProductTypeCode: Array<Scalars['String']['output']>;
  relatedFormatProducts: Array<CatalogProductGraphqlModel>;
  searchable: Scalars['Boolean']['output'];
  /** The slug of the catalog product */
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** The summary of the catalog product */
  summary?: Maybe<Scalars['String']['output']>;
  /** The tenant of the catalog product */
  tenant: Scalars['String']['output'];
};


export type CatalogProductGraphqlModelDisplayVariationArgs = {
  input?: InputMaybe<CatalogProductDisplayVariationInput>;
};


export type CatalogProductGraphqlModelRecommendedVariationsArgs = {
  input?: InputMaybe<CatalogProductDisplayVariationInput>;
};

export type CatalogProductMetadataGraphqlModel = {
  __typename?: 'CatalogProductMetadataGraphqlModel';
  /** Catalog Product Metadata Descrition */
  description?: Maybe<Scalars['String']['output']>;
  /** Catalog Product Metadata Title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CatalogProductOptionTypeCollection = {
  __typename?: 'CatalogProductOptionTypeCollection';
  items: Array<CatalogProductOptionTypeGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_BaseFilterInputType = {
  allowedSampleCombinationCodes?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_BaseFilterInputType>>;
  catalogProductCollectionCode?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductFormatCode?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductSuiteCode?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<Id_PropertyFilterInputType>;
  forbiddenCombinationsCodes?: InputMaybe<String_PropertyFilterInputType>;
  forcePhotoshop?: InputMaybe<Boolean_PropertyFilterInputType>;
  isLive?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_BaseFilterInputType>>;
  orientation?: InputMaybe<String_PropertyFilterInputType>;
  photos?: InputMaybe<Number_PropertyFilterInputType>;
  position?: InputMaybe<Number_PropertyFilterInputType>;
  relatedFormatProductTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  searchable?: InputMaybe<Boolean_PropertyFilterInputType>;
  slug?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary?: InputMaybe<String_PropertyFilterInputType>;
  tenant?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_FilterInputType = {
  allowedSampleCombinationCodes?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_BaseFilterInputType>>;
  catalogProductCollectionCode?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductFormatCode?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductSuiteCode?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<Id_PropertyFilterInputType>;
  forbiddenCombinationsCodes?: InputMaybe<String_PropertyFilterInputType>;
  forcePhotoshop?: InputMaybe<Boolean_PropertyFilterInputType>;
  isLive?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_BaseFilterInputType>>;
  orientation?: InputMaybe<String_PropertyFilterInputType>;
  photos?: InputMaybe<Number_PropertyFilterInputType>;
  position?: InputMaybe<Number_PropertyFilterInputType>;
  relatedFormatProductTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  searchable?: InputMaybe<Boolean_PropertyFilterInputType>;
  slug?: InputMaybe<String_PropertyFilterInputType>;
  status?: InputMaybe<String_PropertyFilterInputType>;
  summary?: InputMaybe<String_PropertyFilterInputType>;
  tenant?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_SortingInputType = {
  allowedSampleCombinationCodes?: InputMaybe<SortType>;
  catalogProductCollectionCode?: InputMaybe<SortType>;
  catalogProductFormatCode?: InputMaybe<SortType>;
  catalogProductSuiteCode?: InputMaybe<SortType>;
  catalogProductTypeCode?: InputMaybe<SortType>;
  externalId?: InputMaybe<SortType>;
  forbiddenCombinationsCodes?: InputMaybe<SortType>;
  forcePhotoshop?: InputMaybe<SortType>;
  isLive?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  orientation?: InputMaybe<SortType>;
  photos?: InputMaybe<SortType>;
  position?: InputMaybe<SortType>;
  relatedFormatProductTypeCode?: InputMaybe<SortType>;
  searchable?: InputMaybe<SortType>;
  slug?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
  summary?: InputMaybe<SortType>;
  tenant?: InputMaybe<SortType>;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_BaseFilterInputType = {
  analyticsAlias?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  designFileControllingOption?: InputMaybe<Boolean_PropertyFilterInputType>;
  designMockupFileControllingOption?: InputMaybe<Boolean_PropertyFilterInputType>;
  imageControllingOption?: InputMaybe<Boolean_PropertyFilterInputType>;
  isFacetable?: InputMaybe<Boolean_PropertyFilterInputType>;
  isSearchable?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_BaseFilterInputType>>;
  searchAlias?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_FilterInputType = {
  analyticsAlias?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  designFileControllingOption?: InputMaybe<Boolean_PropertyFilterInputType>;
  designMockupFileControllingOption?: InputMaybe<Boolean_PropertyFilterInputType>;
  imageControllingOption?: InputMaybe<Boolean_PropertyFilterInputType>;
  isFacetable?: InputMaybe<Boolean_PropertyFilterInputType>;
  isSearchable?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_BaseFilterInputType>>;
  searchAlias?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_SortingInputType = {
  analyticsAlias?: InputMaybe<SortType>;
  code?: InputMaybe<SortType>;
  designFileControllingOption?: InputMaybe<SortType>;
  designMockupFileControllingOption?: InputMaybe<SortType>;
  imageControllingOption?: InputMaybe<SortType>;
  isFacetable?: InputMaybe<SortType>;
  isSearchable?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  searchAlias?: InputMaybe<SortType>;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_BaseFilterInputType = {
  and?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_BaseFilterInputType>>;
  catalogProductOptionTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  forbiddenCombinations?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_BaseFilterInputType>>;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_FilterInputType = {
  and?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_BaseFilterInputType>>;
  catalogProductOptionTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  forbiddenCombinations?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_BaseFilterInputType>>;
};

export type CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_SortingInputType = {
  catalogProductOptionTypeCode?: InputMaybe<SortType>;
  code?: InputMaybe<SortType>;
  externalId?: InputMaybe<SortType>;
  forbiddenCombinations?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
};

export type CatalogProductOptionTypeFindOneByCodeInput = {
  /** string */
  code: Scalars['String']['input'];
};

export type CatalogProductOptionTypeGraphqlModel = {
  __typename?: 'CatalogProductOptionTypeGraphqlModel';
  /** Analytics alias name used on tracking events */
  analyticsAlias?: Maybe<Scalars['String']['output']>;
  /** Unique Code */
  code: Scalars['String']['output'];
  /** Indicate if this attribute is used to associate customizer file */
  designFileControllingOption: Scalars['Boolean']['output'];
  /** Indicate if this attribute is used to associate mockup customizer file */
  designMockupFileControllingOption: Scalars['Boolean']['output'];
  /** Indicate if this attribute is used to associate image file */
  imageControllingOption: Scalars['Boolean']['output'];
  /** Indicate if this attribute is used for search faceting */
  isFacetable: Scalars['Boolean']['output'];
  /** Indicate if this attribute is used for search */
  isSearchable: Scalars['Boolean']['output'];
  /** Option Value Display Name */
  name: Scalars['String']['output'];
  /** Search alias name used on the frontend */
  searchAlias?: Maybe<Scalars['String']['output']>;
  values: CatalogProductOptionValueCollection;
};


export type CatalogProductOptionTypeGraphqlModelValuesArgs = {
  paginate?: InputMaybe<PaginatorInputArgs>;
};

export type CatalogProductOptionTypeQuery = {
  __typename?: 'CatalogProductOptionTypeQuery';
  findAll: Array<CatalogProductOptionTypeGraphqlModel>;
  findOneByCode: CatalogProductOptionTypeGraphqlModel;
};


export type CatalogProductOptionTypeQueryFindOneByCodeArgs = {
  input: CatalogProductOptionTypeFindOneByCodeInput;
};

export type CatalogProductOptionValueCollection = {
  __typename?: 'CatalogProductOptionValueCollection';
  items: Array<CatalogProductOptionValueGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductOptionValueDisplayGraphqlModel = {
  __typename?: 'CatalogProductOptionValueDisplayGraphqlModel';
  /** Option value background (optional) */
  background?: Maybe<Scalars['String']['output']>;
  /** Option value description (optional) */
  description?: Maybe<Scalars['String']['output']>;
  /** Option value iconUrl (optional) */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** Option Value name */
  name?: Maybe<Scalars['String']['output']>;
  /** Option value order (optional) */
  order?: Maybe<Scalars['Float']['output']>;
  /** Option Value slug */
  slug?: Maybe<Scalars['String']['output']>;
};

export type CatalogProductOptionValueFindAllByTypesInput = {
  /** Catalog product option value type codes */
  codes: Array<Scalars['String']['input']>;
};

export type CatalogProductOptionValueFindOneByCodeInput = {
  /** string */
  code: Scalars['String']['input'];
};

export type CatalogProductOptionValueGraphqlModel = {
  __typename?: 'CatalogProductOptionValueGraphqlModel';
  catalogProductOptionType: CatalogProductOptionTypeGraphqlModel;
  /** Option Value Type Code */
  catalogProductOptionTypeCode: Scalars['String']['output'];
  /** Internal ID */
  code: Scalars['String']['output'];
  /** Option Value Type Code */
  display?: Maybe<CatalogProductOptionValueDisplayGraphqlModel>;
  /** Option value external ID */
  externalId: Scalars['String']['output'];
  forbiddenCombinations: Array<Array<Scalars['String']['output']>>;
  /** Option value name */
  name: Scalars['String']['output'];
  /** Option Value Type Code */
  printer?: Maybe<CatalogProductOptionValuePrinterGraphqlModel>;
};

export type CatalogProductOptionValuePrinterGraphqlModel = {
  __typename?: 'CatalogProductOptionValuePrinterGraphqlModel';
  /** Indicate printer configuration for option value Printer Name (value send to printer for this option value) */
  printerName?: Maybe<Scalars['String']['output']>;
  /** Indicate printer configuration for option value VariablePrinting */
  variablePrinting?: Maybe<Scalars['Boolean']['output']>;
};

export type CatalogProductOptionValueQuery = {
  __typename?: 'CatalogProductOptionValueQuery';
  findAll: Array<CatalogProductOptionValueGraphqlModel>;
  findAllByTypes: Array<CatalogProductOptionValueGraphqlModel>;
  findOneByCode: CatalogProductOptionValueGraphqlModel;
};


export type CatalogProductOptionValueQueryFindAllByTypesArgs = {
  input: CatalogProductOptionValueFindAllByTypesInput;
};


export type CatalogProductOptionValueQueryFindOneByCodeArgs = {
  input: CatalogProductOptionValueFindOneByCodeInput;
};

export type CatalogProductQuery = {
  __typename?: 'CatalogProductQuery';
  findByAssetValues: Array<CatalogProductGraphqlModel>;
  findMany: Array<CatalogProductGraphqlModel>;
  findOne: CatalogProductGraphqlModel;
};


export type CatalogProductQueryFindByAssetValuesArgs = {
  input: CatalogProductGraphqlFindManyByAssetValuesInput;
};


export type CatalogProductQueryFindManyArgs = {
  input: CatalogProductGraphqlFindManyInput;
};


export type CatalogProductQueryFindOneArgs = {
  input: CatalogProductGraphqlFindOneInput;
};

export type CatalogProductRelationshipFindManyBySkuInput = {
  sourceEntitySku: Scalars['String']['input'];
};

export type CatalogProductRelationshipFindOneByTypeAndSkuInput = {
  sourceEntitySku: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CatalogProductRelationshipGraphqlModel = {
  __typename?: 'CatalogProductRelationshipGraphqlModel';
  /** The external identifier of the relationship */
  externalId: Scalars['String']['output'];
  /** The unique identifier of the relationship */
  id: Scalars['String']['output'];
  /** Indicates if the relationship is generic */
  isGeneric: Scalars['Boolean']['output'];
  /** The name of the relationship */
  name: Scalars['String']['output'];
  /** The source entity code of the relationship */
  sourceEntityCode: Scalars['String']['output'];
  /** The target entity codes of the relationship */
  targetEntityCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** The type of the relationship */
  type: Scalars['String']['output'];
};

export type CatalogProductRelationshipQuery = {
  __typename?: 'CatalogProductRelationshipQuery';
  findManyBySku: Array<CatalogProductRelationshipGraphqlModel>;
  findOneByTypeAndSku: CatalogProductRelationshipGraphqlModel;
};


export type CatalogProductRelationshipQueryFindManyBySkuArgs = {
  input: CatalogProductRelationshipFindManyBySkuInput;
};


export type CatalogProductRelationshipQueryFindOneByTypeAndSkuArgs = {
  input: CatalogProductRelationshipFindOneByTypeAndSkuInput;
};

export type CatalogProductSuiteCollection = {
  __typename?: 'CatalogProductSuiteCollection';
  items: Array<CatalogProductSuiteGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_BaseFilterInputType = {
  and?: InputMaybe<Array<CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  designedBy?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  hideProductDetailPage?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_BaseFilterInputType>>;
  seasons?: InputMaybe<String_PropertyFilterInputType>;
  slug?: InputMaybe<String_PropertyFilterInputType>;
  styles?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_FilterInputType = {
  and?: InputMaybe<Array<CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  designedBy?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  hideProductDetailPage?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_BaseFilterInputType>>;
  seasons?: InputMaybe<String_PropertyFilterInputType>;
  slug?: InputMaybe<String_PropertyFilterInputType>;
  styles?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_SortingInputType = {
  code?: InputMaybe<SortType>;
  designedBy?: InputMaybe<SortType>;
  externalId?: InputMaybe<SortType>;
  hideProductDetailPage?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  seasons?: InputMaybe<SortType>;
  slug?: InputMaybe<SortType>;
  styles?: InputMaybe<SortType>;
};

export type CatalogProductSuiteGraphqlModel = {
  __typename?: 'CatalogProductSuiteGraphqlModel';
  /** The product suite code */
  code: Scalars['String']['output'];
  /** The name of the designer */
  designedBy?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the product suite */
  externalId: Scalars['String']['output'];
  /** Whether the product suite should be hidden from the product detail page */
  hideProductDetailPage: Scalars['Boolean']['output'];
  /** The product suite name */
  name: Scalars['String']['output'];
  /** The seasons the product suite is available */
  seasons: Array<Scalars['String']['output']>;
  /** The Friendly URL identifier for the product suite */
  slug: Scalars['String']['output'];
  /** The styles of the product suite */
  styles: Array<Scalars['String']['output']>;
};

export type CatalogProductTypeCollection = {
  __typename?: 'CatalogProductTypeCollection';
  items: Array<CatalogProductTypeGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_BaseFilterInputType = {
  and?: InputMaybe<Array<CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_BaseFilterInputType>>;
  assetProductAlias?: InputMaybe<String_PropertyFilterInputType>;
  assetProductCode?: InputMaybe<String_PropertyFilterInputType>;
  childProductTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  designFilePageCount?: InputMaybe<Number_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  imageTypes?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_BaseFilterInputType>>;
  searchable?: InputMaybe<Boolean_PropertyFilterInputType>;
  slug?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_FilterInputType = {
  and?: InputMaybe<Array<CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_BaseFilterInputType>>;
  assetProductAlias?: InputMaybe<String_PropertyFilterInputType>;
  assetProductCode?: InputMaybe<String_PropertyFilterInputType>;
  childProductTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  designFilePageCount?: InputMaybe<Number_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  imageTypes?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_BaseFilterInputType>>;
  searchable?: InputMaybe<Boolean_PropertyFilterInputType>;
  slug?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_SortingInputType = {
  assetProductAlias?: InputMaybe<SortType>;
  assetProductCode?: InputMaybe<SortType>;
  childProductTypeCode?: InputMaybe<SortType>;
  code?: InputMaybe<SortType>;
  designFilePageCount?: InputMaybe<SortType>;
  externalId?: InputMaybe<SortType>;
  imageTypes?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  searchable?: InputMaybe<SortType>;
  slug?: InputMaybe<SortType>;
};

export type CatalogProductTypeGraphqlFindManyInput = {
  /** SKU codes for the product type */
  codes: Array<Scalars['String']['input']>;
};

export type CatalogProductTypeGraphqlModel = {
  __typename?: 'CatalogProductTypeGraphqlModel';
  /** Asset Product Alias */
  assetProductAlias: Scalars['String']['output'];
  /** Asset Product Code */
  assetProductCode: Scalars['String']['output'];
  categories: Array<CatalogProductCategoryGraphqlModel>;
  childProductType?: Maybe<CatalogProductTypeGraphqlModel>;
  /** Code of the child Product Type */
  childProductTypeCode?: Maybe<Scalars['String']['output']>;
  /** The code of the catalog product type */
  code: Scalars['String']['output'];
  /** The customizer safety lines of the catalog product type */
  customizerSafetyLines: Array<CanvasSafetyLine>;
  /** Design File Page Count */
  designFilePageCount: Scalars['Float']['output'];
  /** The external id of the catalog product type */
  externalId: Scalars['String']['output'];
  /** The image types of the catalog product type */
  imageTypes: Array<Scalars['String']['output']>;
  /** The name of the catalog product type */
  name: Scalars['String']['output'];
  /** The printing options of the catalog product type */
  printingOptions: CatalogProductTypePrintingOptionsGraphqlModel;
  /** The searchable of the catalog product type */
  searchable: Scalars['Boolean']['output'];
  /** The slug of the catalog product type */
  slug: Scalars['String']['output'];
};

export type CatalogProductTypePrintingOptionsGraphqlModel = {
  __typename?: 'CatalogProductTypePrintingOptionsGraphqlModel';
  /** The duplex printing of the catalog product type */
  duplexPrinting: Scalars['Boolean']['output'];
  /** The envelope size of the catalog product type */
  envelopeSize: Scalars['String']['output'];
  /** The folded of the catalog product type */
  folded: Scalars['Boolean']['output'];
  /** The height of the catalog product type */
  height: Scalars['Float']['output'];
  /** The orientation of the catalog product type */
  orientation: Scalars['Boolean']['output'];
  /** The variable printing of the catalog product type */
  variablePrinting: Scalars['Boolean']['output'];
  /** The width of the catalog product type */
  width: Scalars['Float']['output'];
};

export type CatalogProductTypeQuery = {
  __typename?: 'CatalogProductTypeQuery';
  findMany: Array<CatalogProductTypeGraphqlModel>;
};


export type CatalogProductTypeQueryFindManyArgs = {
  input: CatalogProductTypeGraphqlFindManyInput;
};

export type CatalogProductVariationCollection = {
  __typename?: 'CatalogProductVariationCollection';
  items: Array<CatalogProductVariationGraphqlModel>;
  pagination: PaginationData;
};

export type CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_BaseFilterInputType = {
  and?: InputMaybe<Array<CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_BaseFilterInputType>>;
  catalogProductExternalId?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductSlug?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductSuiteCode?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  isActive?: InputMaybe<Boolean_PropertyFilterInputType>;
  isSample?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_BaseFilterInputType>>;
  productStatus?: InputMaybe<String_PropertyFilterInputType>;
  tenant?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_FilterInputType = {
  and?: InputMaybe<Array<CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_BaseFilterInputType>>;
  catalogProductExternalId?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductSlug?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductSuiteCode?: InputMaybe<String_PropertyFilterInputType>;
  catalogProductTypeCode?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  isActive?: InputMaybe<Boolean_PropertyFilterInputType>;
  isSample?: InputMaybe<Boolean_PropertyFilterInputType>;
  or?: InputMaybe<Array<CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_BaseFilterInputType>>;
  productStatus?: InputMaybe<String_PropertyFilterInputType>;
  tenant?: InputMaybe<String_PropertyFilterInputType>;
};

export type CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_SortingInputType = {
  catalogProductExternalId?: InputMaybe<SortType>;
  catalogProductSlug?: InputMaybe<SortType>;
  catalogProductSuiteCode?: InputMaybe<SortType>;
  catalogProductTypeCode?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  isActive?: InputMaybe<SortType>;
  isSample?: InputMaybe<SortType>;
  productStatus?: InputMaybe<SortType>;
  tenant?: InputMaybe<SortType>;
};

export type CatalogProductVariationFindBestMatchingVariationInput = {
  /** The slug of the catalog product, when searching by option values, it provides context to narrow the search  */
  catalogProductSlug?: InputMaybe<Scalars['String']['input']>;
  /** Used to match the variation that matches most of the product option values */
  optionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Variations SHOULD contain the provided option values */
  requiredOptionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Used to match de variation by ID, when provided, the other fields are ignored. */
  variationId?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogProductVariationGraphqlModel = {
  __typename?: 'CatalogProductVariationGraphqlModel';
  catalogProduct: CatalogProductGraphqlModel;
  /** The external id of the product */
  catalogProductExternalId: Scalars['String']['output'];
  /** The slug of the product */
  catalogProductSlug: Scalars['String']['output'];
  /** The Unique code of the product suite */
  catalogProductSuiteCode: Scalars['String']['output'];
  /** The Unique code of the product type */
  catalogProductTypeCode: Scalars['String']['output'];
  /** The ids of the customizer files of the variation */
  customizerFileIds: Array<Scalars['String']['output']>;
  customizerFiles: Array<VariationCustomizerFileGraphqlModel>;
  displayProductOptions: Array<VariationDisplayProductOptionGraphqlModel>;
  friendlyPriceTiers: Array<VariationFriendlyPriceTierGraphqlModel>;
  /** The id of the variation */
  id: Scalars['String']['output'];
  /** The ids of the images of the variation */
  imageIds: Array<Scalars['String']['output']>;
  images: Array<VariationImageGraphqlModel>;
  initializationInstructions: Array<Scalars['JSON']['output']>;
  /** Indicate if the variation is active */
  isActive: Scalars['Boolean']['output'];
  /** Is the variation a sample */
  isSample: Scalars['Boolean']['output'];
  /** The option values of the variation */
  optionValues: Array<VariationFlatProductOptionValueGraphqlModel>;
  /** The price modifiers of the variation */
  priceModifiers: Array<VariationPriceModifierGraphqlModel>;
  /** The price tiers of the variation */
  priceTiers: Array<VariationPriceTierGraphqlModel>;
  /** The status of the product */
  productStatus: Scalars['String']['output'];
  relationships: CatalogProductVariationCollection;
  /** The brand/tenant the variation belongs to */
  tenant: Scalars['String']['output'];
};


export type CatalogProductVariationGraphqlModelImagesArgs = {
  input?: InputMaybe<CatalogProductVariationImageInput>;
};


export type CatalogProductVariationGraphqlModelInitializationInstructionsArgs = {
  input: InstructionsInput;
};


export type CatalogProductVariationGraphqlModelRelationshipsArgs = {
  paginate?: InputMaybe<PaginatorInputArgs>;
  relationshipArgs: RelationshipAsFieldGraphqlQueryArgs;
};

export type CatalogProductVariationImageInput = {
  /** role filter  */
  role: FieldValueInputFilterInput;
};

export type CatalogProductVariationQuery = {
  __typename?: 'CatalogProductVariationQuery';
  findBestMatchingVariation: CatalogProductVariationGraphqlModel;
};


export type CatalogProductVariationQueryFindBestMatchingVariationArgs = {
  input: CatalogProductVariationFindBestMatchingVariationInput;
};

export type CatalogSpineLineGraphqlModel = {
  __typename?: 'CatalogSpineLineGraphqlModel';
  /** The bleed of the fold line */
  bleed?: Maybe<Scalars['Float']['output']>;
  /** The fill color of the spine line */
  fillColor?: Maybe<Scalars['String']['output']>;
  /** If the fold line is vertical */
  isVertical: Scalars['Boolean']['output'];
  /** The margin of the fold line */
  margin?: Maybe<Scalars['String']['output']>;
  /** The pen of the fold line */
  pen?: Maybe<CatalogFoldLinePenGraphqlModel>;
  /** The width of the spine line */
  width?: Maybe<Scalars['Float']['output']>;
};

export type Category = {
  __typename?: 'Category';
  /**
   * Name of the product category
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * Slug of the product category
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
};

export type CategoryPageResolver_FindByUrl_BaseFilterInputType = {
  and?: InputMaybe<Array<CategoryPageResolver_FindByUrl_BaseFilterInputType>>;
  bubbleComponentId?: InputMaybe<String_PropertyFilterInputType>;
  categoryUrl?: InputMaybe<String_PropertyFilterInputType>;
  displayName?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  facetIds?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CategoryPageResolver_FindByUrl_BaseFilterInputType>>;
  pricingRanges?: InputMaybe<String_PropertyFilterInputType>;
  productCategoryId?: InputMaybe<String_PropertyFilterInputType>;
  seoTags?: InputMaybe<Json_PropertyFilterInputType>;
};

export type CategoryPageResolver_FindByUrl_FilterInputType = {
  and?: InputMaybe<Array<CategoryPageResolver_FindByUrl_BaseFilterInputType>>;
  bubbleComponentId?: InputMaybe<String_PropertyFilterInputType>;
  categoryUrl?: InputMaybe<String_PropertyFilterInputType>;
  displayName?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  facetIds?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<CategoryPageResolver_FindByUrl_BaseFilterInputType>>;
  pricingRanges?: InputMaybe<String_PropertyFilterInputType>;
  productCategoryId?: InputMaybe<String_PropertyFilterInputType>;
  seoTags?: InputMaybe<Json_PropertyFilterInputType>;
};

export type Colors = {
  __typename?: 'Colors';
  /**
   * Color hex code.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  colorHex: Scalars['String']['output'];
  /**
   * Name of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * Sku of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sku: Scalars['String']['output'];
  /**
   * Slug of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  /** Coupon code */
  code: Scalars['String']['output'];
  /** Discounted amount provided by the coupon */
  discountedAmount?: Maybe<Scalars['Float']['output']>;
  /** Coupon ID */
  id: Scalars['String']['output'];
};

export type CreateFavoriteInput = {
  /** External Id */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Variation Id */
  variationId: Scalars['String']['input'];
};

export type CreatePortfolioItemInput = {
  customizer?: InputMaybe<CustomizerInput>;
  fileType?: InputMaybe<PortfolioItemFileType>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  selectableOptionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  urlPrintOverride?: InputMaybe<Scalars['String']['input']>;
  variationId: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  /** The email of the customer. */
  email: Scalars['String']['output'];
  /** The first name of the customer. */
  firstName: Scalars['String']['output'];
  /** The id of the customer. */
  id: Scalars['Int']['output'];
  /** The last name of the customer. */
  lastName: Scalars['String']['output'];
  /** The phone number of the customer. */
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerId = {
  __typename?: 'CustomerId';
  /** The id of the customer. */
  id: Scalars['Int']['output'];
};

export type Customizer = {
  __typename?: 'Customizer';
  /** Version of Customer's Canvas that the state file was initially created with. */
  ccInitialVersion?: Maybe<Scalars['String']['output']>;
  /** Version of Customer's Canvas that the state file was last saved with. */
  ccVersion?: Maybe<Scalars['String']['output']>;
  /** Customizer id for this customized design. */
  stateId: Scalars['String']['output'];
  /** URL to the design pdf that should be used for printing. */
  urlPrint: Scalars['String']['output'];
  urlProofs: Array<UrlProof>;
  /** Customizer user id. */
  userId: Scalars['String']['output'];
};

export type CustomizerDesignFilePath = {
  __typename?: 'CustomizerDesignFilePath';
  /**
   * Path for the back side of the customizer design file for a product variation.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  back?: Maybe<Scalars['String']['output']>;
  /**
   * Path for the front side of the customizer design file for a product variation.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  front?: Maybe<Scalars['String']['output']>;
  /**
   * Path for the mockup customizer design file used by a foil product variation
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  mockup?: Maybe<Scalars['String']['output']>;
};

export type CustomizerInput = {
  ccInitialVersion?: InputMaybe<Scalars['String']['input']>;
  ccVersion?: InputMaybe<Scalars['String']['input']>;
  stateId: Scalars['String']['input'];
  urlPrint: Scalars['String']['input'];
  urlProofs: Array<UrlProofInput>;
  userId: Scalars['String']['input'];
};

export type Date_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notbetween?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  notin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultProductOptions = {
  __typename?: 'DefaultProductOptions';
  /**
   * Default Foil type for the suite.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  foilType?: Maybe<ProductOption>;
};

export type DeleteDraftGroupInput = {
  /** Draft Group Id. */
  draftGroupId: Scalars['String']['input'];
};

export type DeleteDraftsItemInput = {
  /** Draft item id. */
  itemId: Scalars['String']['input'];
};

export type DeleteFavoriteInput = {
  /** External Id */
  externalId: Scalars['String']['input'];
};

export type Draft = {
  __typename?: 'Draft';
  /** ID of the draft group. */
  draftGroupId: Scalars['UUID']['output'];
  /** Id of the draft item. */
  id: Scalars['String']['output'];
  /** The absolute url of the image of the draft with all of the user's customizations */
  image?: Maybe<Scalars['String']['output']>;
  /** Parent item id of the draft */
  parentItemId?: Maybe<Scalars['String']['output']>;
  /** ID of the associated portfolioItem */
  portfolioItem: PortfolioItem;
  /**
   * Price of the associated variant
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  price?: Maybe<Scalars['String']['output']>;
  /** Selected product quantity */
  quantity: Scalars['Int']['output'];
  /** Last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type DraftCartMutation = {
  __typename?: 'DraftCartMutation';
  moveCartItemToDrafts?: Maybe<DraftCartResult>;
  moveDraftItemToCart: SingleItemCartResult;
};


export type DraftCartMutationMoveCartItemToDraftsArgs = {
  itemId: Scalars['String']['input'];
};


export type DraftCartMutationMoveDraftItemToCartArgs = {
  input: AddDraftToCartInput;
};

export type DraftCartResult = {
  __typename?: 'DraftCartResult';
  /** Cart */
  cart?: Maybe<CartDetails>;
  /** Draft */
  draft?: Maybe<Draft>;
};

export type DraftsGroupDeletedResult = {
  __typename?: 'DraftsGroupDeletedResult';
  /** Total drafts deleted */
  count: Scalars['Int']['output'];
};

export type DraftsMutation = {
  __typename?: 'DraftsMutation';
  removeItem: Draft;
  removeItemsByDraftGroup: DraftsGroupDeletedResult;
  upsertItem?: Maybe<Draft>;
};


export type DraftsMutationRemoveItemArgs = {
  input: DeleteDraftsItemInput;
};


export type DraftsMutationRemoveItemsByDraftGroupArgs = {
  input: DeleteDraftGroupInput;
};


export type DraftsMutationUpsertItemArgs = {
  input: UpsertItemToDraftsInput;
};

export type DraftsQuery = {
  __typename?: 'DraftsQuery';
  findAllForUser: GetDraftsResult;
  findOneByPortfolio?: Maybe<Draft>;
};


export type DraftsQueryFindOneByPortfolioArgs = {
  portfolioItemId: Scalars['String']['input'];
};

export type FacetOptionGraphqlModel = CatalogProductFormatGraphqlModel | CatalogProductOptionValueGraphqlModel;

export type FavoriteGraphqlModel = {
  __typename?: 'FavoriteGraphqlModel';
  externalId: Scalars['String']['output'];
  variation: CatalogProductVariationGraphqlModel;
};

export type FavoritesMutation = {
  __typename?: 'FavoritesMutation';
  deleteOne?: Maybe<Scalars['Boolean']['output']>;
  upsertOne?: Maybe<FavoriteGraphqlModel>;
};


export type FavoritesMutationDeleteOneArgs = {
  deleteOneInput: DeleteFavoriteInput;
};


export type FavoritesMutationUpsertOneArgs = {
  upsertOneInput: CreateFavoriteInput;
};

export type FavoritesQuery = {
  __typename?: 'FavoritesQuery';
  count?: Maybe<Scalars['Float']['output']>;
  findAll?: Maybe<Array<FavoriteGraphqlModel>>;
  findOne?: Maybe<FavoriteGraphqlModel>;
};


export type FavoritesQueryFindAllArgs = {
  paginate?: InputMaybe<PaginatorInputArgs>;
  variationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type FavoritesQueryFindOneArgs = {
  variationId: Scalars['String']['input'];
};

export type FieldValueInputFilterInput = {
  /** equal */
  equal?: InputMaybe<Scalars['String']['input']>;
  /** in */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notIn */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindOneProductInput = {
  /** Selected Variation id. */
  selectedVariationId?: InputMaybe<Scalars['String']['input']>;
  /** Url path to the product. */
  slug: Scalars['String']['input'];
};

export type FoilSampleVariation = {
  __typename?: 'FoilSampleVariation';
  /**
   * Foil sample variation color theme.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  colorTheme?: Maybe<Scalars['String']['output']>;
  /**
   * Foil sample variation theme code.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  foilTheme?: Maybe<Scalars['String']['output']>;
  /**
   * Foil sample variation paperType.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  paperType?: Maybe<Scalars['String']['output']>;
  /**
   * Foil sample variation Id.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  variationId?: Maybe<Scalars['String']['output']>;
};

export type GetDraftsResult = {
  __typename?: 'GetDraftsResult';
  /** Total drafts count */
  count: Scalars['Int']['output'];
  items: Array<Draft>;
};

export type GetRelatedProductInput = {
  /** The product Id */
  catalogProductId: Scalars['String']['input'];
  /** The variation conditioning color, paper, foil, shape... */
  variationId: Scalars['String']['input'];
};

export type Id_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['ID']['input']>>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notbetween?: InputMaybe<Array<Scalars['ID']['input']>>;
  notin?: InputMaybe<Array<Scalars['ID']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InitCanvasInput = {
  /** Draft Group Id */
  draftGroupId: Scalars['String']['input'];
  /** Parent item id of the draft */
  draftParentItemId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Draft. */
  portfolioItemName?: InputMaybe<Scalars['String']['input']>;
  /** The selected product quantity. */
  quantity: Scalars['Int']['input'];
  urlPrintOverride?: InputMaybe<Scalars['String']['input']>;
  variationId: Scalars['String']['input'];
};

export type InitCanvasResult = {
  __typename?: 'InitCanvasResult';
  /** The draft ID */
  draftId: Scalars['String']['output'];
  /** The portfolioItem ID */
  id: Scalars['String']['output'];
};

export type InstructionsInput = {
  /** An override for previewing the instructions when idml has not been enabled on a product yet. */
  previewInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Slug of the product. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the template used for the instructions */
  templateStatus?: InputMaybe<TemplateStatus>;
};

export type ItemAccessories = {
  __typename?: 'ItemAccessories';
  liner?: Maybe<CatalogProductVariationGraphqlModel>;
  plainEnvelope?: Maybe<CatalogProductVariationGraphqlModel>;
  printedEnvelope?: Maybe<CatalogProductVariationGraphqlModel>;
};

export type Json_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['JSON']['input']>>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  neq?: InputMaybe<Scalars['JSON']['input']>;
  notbetween?: InputMaybe<Array<Scalars['JSON']['input']>>;
  notin?: InputMaybe<Array<Scalars['JSON']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuFindOneResolver_FindOne_BaseFilterInputType = {
  and?: InputMaybe<Array<MenuFindOneResolver_FindOne_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<MenuFindOneResolver_FindOne_BaseFilterInputType>>;
};

export type MenuFindOneResolver_FindOne_FilterInputType = {
  and?: InputMaybe<Array<MenuFindOneResolver_FindOne_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  externalId?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<MenuFindOneResolver_FindOne_BaseFilterInputType>>;
};

export type MenuGraphqlModel = {
  __typename?: 'MenuGraphqlModel';
  /** Menu code */
  code: Scalars['String']['output'];
  /** Menu description */
  description: Scalars['String']['output'];
  /** Menu Unique Code */
  externalId: Scalars['String']['output'];
  /** Id of the Menu */
  id: Scalars['String']['output'];
  /** Menu name */
  name: Scalars['String']['output'];
  /** Menu Tree structure */
  treeStructure: Scalars['JSON']['output'];
};

export type MultiItemCartResult = {
  __typename?: 'MultiItemCartResult';
  /** Updated cart */
  cart?: Maybe<CartDetails>;
  /** Updated items */
  items?: Maybe<Array<CartDetailsItem>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  canvas: CanvasMutation;
  cart: CartMutation;
  draftCart: DraftCartMutation;
  drafts: DraftsMutation;
  favorites: FavoritesMutation;
  order: OrderMutation;
  portfolioItem: PortfolioItemMutation;
  recentlyViewed: RecentlyViewedMutation;
  session: SessionMutation;
};

export type Number_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['Float']['input']>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notbetween?: InputMaybe<Array<Scalars['Float']['input']>>;
  notin?: InputMaybe<Array<Scalars['Float']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionValue = {
  __typename?: 'OptionValue';
  /** Visible name of the option */
  name: Scalars['String']['output'];
  /** References the productOptionType.sku */
  optionId: Scalars['String']['output'];
  /** References the productOptionType.name */
  valueId: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  /** The billing address for the order. */
  billingAddress: Address;
  /** The customer who placed the order. */
  customer: Customer;
  /** The date the order was created */
  date: Scalars['String']['output'];
  /** Id of the order. */
  id: Scalars['Int']['output'];
  /** The items in the order. */
  items: Array<OrderItem>;
  /** The shipping address for the order. */
  shippingAddress: ShippingAddress;
  /** The current status of the order */
  status: OrderStatus;
  /** The total costs for the order. */
  totals: OrderTotals;
};

export type OrderCollection = {
  __typename?: 'OrderCollection';
  items: Array<Order>;
  pagination: PaginationData;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  displayVariation?: Maybe<CatalogProductVariationGraphqlModel>;
  /** The id of the order item. */
  id: Scalars['Int']['output'];
  portfolioItem?: Maybe<PortfolioItem>;
  /** Image from the portfolio item if it exists, otherwise the hero image. */
  previewImage?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  /** The quantity of the order item. */
  quantity: Scalars['Int']['output'];
  reorderEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The variation to use when reordering the item. */
  reorderVariationId?: Maybe<Scalars['String']['output']>;
  /** The total price of the order item. */
  totalPrice: Scalars['Float']['output'];
  /** The unit price of the order item. */
  unitPrice: Scalars['Float']['output'];
  variation: Variation;
};

export type OrderMutation = {
  __typename?: 'OrderMutation';
  addItem?: Maybe<OrderResult>;
};


export type OrderMutationAddItemArgs = {
  input: AddItemToOrderInput;
};

export type OrderQuery = {
  __typename?: 'OrderQuery';
  /** @deprecated Use findMany instead. */
  findAll?: Maybe<PaginatedOrders>;
  findMany: OrderCollection;
  findOne?: Maybe<Order>;
  getAllStatuses: OrderStatuses;
};


export type OrderQueryFindManyArgs = {
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<OrderQueryResolver_FindMany_SortingInputType>;
};


export type OrderQueryFindOneArgs = {
  orderId: Scalars['ID']['input'];
};

export type OrderQueryResolver_FindMany_SortingInputType = {
  date?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  status?: InputMaybe<SortType>;
};

export type OrderResult = {
  __typename?: 'OrderResult';
  /** Id of the order. */
  orderId: Scalars['Int']['output'];
  /** Id of the portfolio item for the added order item. */
  portfolioItemId?: Maybe<Scalars['String']['output']>;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  /** Status name to display for customers. */
  customerLabel?: Maybe<Scalars['String']['output']>;
  /** Status name to display for CX. */
  cxLabel?: Maybe<Scalars['String']['output']>;
  /** Default name of the status in BigCommerce. */
  defaultBcLabel: Scalars['String']['output'];
};

export type OrderStatuses = {
  __typename?: 'OrderStatuses';
  statuses?: Maybe<Array<OrderStatus>>;
};

export type OrderTotals = {
  __typename?: 'OrderTotals';
  /** The discount applied to the order */
  discount: Scalars['Float']['output'];
  /** The total cost of the order. */
  shipping: Scalars['Float']['output'];
  /** The sub-total cost of the order. */
  subTotal: Scalars['Float']['output'];
  /** The taxes paid for the order. */
  taxes: Scalars['Float']['output'];
  /** The total cost of the order. */
  totalAmount: Scalars['Float']['output'];
};

export enum Orientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export type PaginatedOrders = {
  __typename?: 'PaginatedOrders';
  /** The collection of orders. */
  orders: Array<Order>;
};

export type PaginationData = {
  __typename?: 'PaginationData';
  page: Scalars['Float']['output'];
  perPage: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type PaginatorInputArgs = {
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
};

export type ParentProductBreadcrumbs = {
  __typename?: 'ParentProductBreadcrumbs';
  /** Parent product slug */
  slug: Scalars['String']['output'];
  /** Parent type data for review page */
  type: ProductOption;
};

export type PlpFacetGraphqlModel = {
  __typename?: 'PlpFacetGraphqlModel';
  /** Id of the algolia facet */
  externalId: Scalars['String']['output'];
  /** Option value type code of the algolia facet */
  facetName?: Maybe<Scalars['String']['output']>;
  /** Option value type code of the algolia facet */
  optionValueTypeCode: Scalars['String']['output'];
  /** optionValues or formats to be shown */
  options: Array<FacetOptionGraphqlModel>;
  /** Algolia facet of the algolia facet */
  plpFacet: Scalars['String']['output'];
  /** Show zero result options of the algolia facet */
  showZeroResultOptions: Scalars['Boolean']['output'];
  /** Title of the algolia facet */
  title: Scalars['String']['output'];
};

export type PlpPageGraphqlModel = {
  __typename?: 'PlpPageGraphqlModel';
  bubbleComponent: BubbleComponentGraphqlModel;
  /** bubble component in the plp page */
  bubbleComponentId: Scalars['String']['output'];
  /** Title to show of the plp page */
  categoryUrl: Scalars['String']['output'];
  /** Title to show of the plp page */
  displayName: Scalars['String']['output'];
  /** Id of the plp page */
  externalId: Scalars['String']['output'];
  /** facet ids in the plp page */
  facetIds: Array<Scalars['String']['output']>;
  /** Name of the plp page */
  name: Scalars['String']['output'];
  plpFacets: Array<PlpFacetGraphqlModel>;
  /** pricing options of the plp page */
  pricingRanges: Array<Scalars['String']['output']>;
  productCategory: CatalogProductCategoryGraphqlModel;
  /** product category in the plp page */
  productCategoryId: Scalars['String']['output'];
  /** seo tags */
  seoTags: Scalars['JSON']['output'];
};

export type PortfolioItem = {
  __typename?: 'PortfolioItem';
  catalogProductVariation: CatalogProductVariationGraphqlModel;
  customizer?: Maybe<Customizer>;
  /** File type the customizer was initialized with. */
  fileType?: Maybe<PortfolioItemFileType>;
  /** Id of the portfolio item. */
  id: Scalars['String']['output'];
  /** Represents if a PortfolioItem has been customized or not */
  isCustomized: Scalars['Boolean']['output'];
  /** Id of the member from membership system. */
  memberId?: Maybe<Scalars['String']['output']>;
  /** Notes from the customer. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The option values available for toggling in the customizer. Only applies if the file type is IDML. */
  selectableOptionValues?: Maybe<Array<Scalars['String']['output']>>;
  /** The id of the Product Customizer Template used to create the state file. Only applies if the file type is IDML. */
  templateId?: Maybe<Scalars['String']['output']>;
  /** Tenant identifier. */
  tenant: Tenant;
  /** If provided, a url to the design pdf that overrides the design generated in the customizer tool. */
  urlPrintOverride?: Maybe<Scalars['String']['output']>;
  /**
   * Represents the unique combination of options selected for the product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  variation: Variation;
  /** Represents the unique combination of options selected for the product. */
  variationId: Scalars['String']['output'];
};

export enum PortfolioItemFileType {
  Idml = 'IDML',
  Psd = 'PSD'
}

export type PortfolioItemInput = {
  customizer?: InputMaybe<CustomizerInput>;
  fileType?: InputMaybe<PortfolioItemFileType>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  selectableOptionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  urlPrintOverride?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioItemMutation = {
  __typename?: 'PortfolioItemMutation';
  create: PortfolioItem;
  update: PortfolioItem;
};


export type PortfolioItemMutationCreateArgs = {
  input: CreatePortfolioItemInput;
};


export type PortfolioItemMutationUpdateArgs = {
  input: UpdatePortfolioItemInput;
};

export type PortfolioItemQuery = {
  __typename?: 'PortfolioItemQuery';
  findOne: PortfolioItem;
};


export type PortfolioItemQueryFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PriceModifier = {
  __typename?: 'PriceModifier';
  /**
   * modifier amount (paperType/foil)
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  amount: Scalars['Float']['output'];
  /**
   * modifier type (paperType/foil)
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  type: Scalars['String']['output'];
};

export type Product = {
  __typename?: 'Product';
  /**
   * Contentful Product Id
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  catalogProductId: Scalars['String']['output'];
  /**
   * Category of the product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  category?: Maybe<Category>;
  /**
   * Description of product from Contentful. Used for SEO purposes
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * display info of product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  displayOptions?: Maybe<ProductDisplayOptions>;
  /**
   * Foil sample variation of product
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  foilSampleVariation?: Maybe<FoilSampleVariation>;
  /**
   * The height of the product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  height: Scalars['Float']['output'];
  /**
   * Product is live (not in preview mode).
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  isLive: Scalars['Boolean']['output'];
  /**
   * Name of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * options variants of product.
   * @deprecated ProductVariationOptions (variationOptions field) instead
   */
  options: ProductOptions;
  /**
   * Parent product info of product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  parentProduct?: Maybe<ProductOption>;
  /**
   * The format of the product, like Postcard, Magnet, All-in-One, etc.  Defaults to Standard
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  productFormat: ProductFormat;
  /**
   * Products that are similar, but differ by their format, like Save The Date Cards vs Save The Date Magnets.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  productTypeSiblings?: Maybe<Array<ProductFormatDetails>>;
  relatedProducts?: Maybe<Array<RelatedProduct>>;
  /**
   * Selected variation SKUs of product
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  selectedVariant?: Maybe<ProductOptionsSkus>;
  /**
   * Slug of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
  /**
   * suite info of product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  suite: Suite;
  /**
   * Description of product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  summary?: Maybe<Scalars['String']['output']>;
  /**
   * type info of product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  type: ProductOption;
  upsellProduct?: Maybe<UpsellProduct>;
  /**
   * Option values associated with the product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  variationOptions?: Maybe<Array<ProductVariationOption>>;
  /**
   * Variations Trie of product
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  variations: Scalars['String']['output'];
  /**
   * The width of the product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  width: Scalars['Float']['output'];
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  /**
   * Collection color
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  color?: Maybe<Scalars['String']['output']>;
  /**
   * Collection design notes image
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  designNoteImageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Collection Image (logo)
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Indicate if Collection must modify the Product badge
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  isInBadge?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicate if Collection must modify the Product breadcrumbs
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  isInBreadcrumbs?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicate if Collection must modify Matching suites
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  isInMatchingSuites?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicate if Collection name must appear in Product title
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  isInTitle?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Collection name
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * Indicate if customization capabilities on canvas must be restricted
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  restrictedCustomerCanvasOption?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Collection slug
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
  /**
   * Collection title
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  title: Scalars['String']['output'];
};

export type ProductDisplayOptions = {
  __typename?: 'ProductDisplayOptions';
  /**
   * Partnership of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  designedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Orientation of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  orientation: Orientation;
  /**
   * Size of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  size: Size;
};

export type ProductFormat = {
  __typename?: 'ProductFormat';
  /**
   * A long string of text that describes the format that will appear in an information pop up
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  description: Scalars['String']['output'];
  /**
   * The URL for an icon that represents the format
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  iconUrl: Scalars['String']['output'];
  /**
   * The URL for an image that represents the format
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  imageUrl: Scalars['String']['output'];
  /**
   * The format of the product, like Postcard, Magnet, All-in-One, etc.  Defaults to Standard
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * Used to denote how expensive the product is. Ex. $$
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  priceNotation: Scalars['String']['output'];
  /**
   * The string that will be used for displaying Compare Formats Modal eg "5.75” x 12” unfolded, 5.75" x 4.5" folded" for AIO.  This can be the same as the sizeShortText.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sizeLongText: Scalars['String']['output'];
  /**
   * The string that will be used for displaying Algolia facet and on the Format Buttons. e.g "5.75” x 12”" for AIO.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sizeShortText: Scalars['String']['output'];
  /**
   * Sku of product format
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sku: Scalars['String']['output'];
};

export type ProductFormatDetails = {
  __typename?: 'ProductFormatDetails';
  /**
   * A long string of text that describes the format that will appear in an information pop up
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  description: Scalars['String']['output'];
  /**
   * The height of the product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  height: Scalars['Float']['output'];
  /**
   * The URL for an icon that represents the format
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  iconUrl: Scalars['String']['output'];
  /**
   * The URL for an image that represents the format
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  imageUrl: Scalars['String']['output'];
  /**
   * The format of the product, like Postcard, Magnet, All-in-One, etc.  Defaults to Standard
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * Used to denote how expensive the product is. Ex. $$
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  priceNotation: Scalars['String']['output'];
  /**
   * The string that will be used for displaying Compare Formats Modal eg "5.75” x 12” unfolded, 5.75" x 4.5" folded" for AIO.  This can be the same as the sizeShortText.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sizeLongText: Scalars['String']['output'];
  /**
   * The string that will be used for displaying Algolia facet and on the Format Buttons. e.g "5.75” x 12”" for AIO.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sizeShortText: Scalars['String']['output'];
  /**
   * Sku of product format
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sku: Scalars['String']['output'];
  /**
   * Slug of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
  /**
   * The width of the product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  width: Scalars['Float']['output'];
};

export type ProductImages = {
  __typename?: 'ProductImages';
  /**
   * image role
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  role: Scalars['String']['output'];
  /**
   * image url of product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  url: Scalars['String']['output'];
};

export type ProductOption = {
  __typename?: 'ProductOption';
  /**
   * Name of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * Sku of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sku: Scalars['String']['output'];
  /**
   * Slug of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
};

export type ProductOptions = {
  __typename?: 'ProductOptions';
  /**
   * Colors of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  colors?: Maybe<Array<Colors>>;
  /**
   * Envelope Printing Options of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  envelopePrinting?: Maybe<Array<ProductOption>>;
  /**
   * Flap Types of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  flapTypes?: Maybe<Array<ProductOption>>;
  /**
   * Foil Types of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  foilTypes?: Maybe<Array<ProductOption>>;
  /**
   * Paper Colors of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  paperColors?: Maybe<Array<ProductOption>>;
  /**
   * Paper Types of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  paperTypes?: Maybe<Array<ProductOption>>;
};

export type ProductOptionsSkus = {
  __typename?: 'ProductOptionsSkus';
  /**
   * SKU colorThemeCode of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  colorThemeCode?: Maybe<Scalars['String']['output']>;
  /**
   * SKU printingOptionCode of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  envelopePrintingOptionCode?: Maybe<Scalars['String']['output']>;
  /**
   * SKU flapType of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  flapTypeCode?: Maybe<Scalars['String']['output']>;
  /**
   * SKU foilCode of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  foilCode?: Maybe<Scalars['String']['output']>;
  /**
   * SKU paperColor of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  paperColorCode?: Maybe<Scalars['String']['output']>;
  /**
   * SKU paperTypeCode of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  paperTypeCode?: Maybe<Scalars['String']['output']>;
};

export type ProductPhotos = {
  __typename?: 'ProductPhotos';
  /** Url of the merchandising image. */
  addressRecipient?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  addressReturn?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  back?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  cardAndRsvp?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  envelopeAndLiner?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  foldedFront?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  front?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  frontAndBack?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  hero?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  inSitu?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  rsvp?: Maybe<Scalars['String']['output']>;
  /** Url of the merchandising image. */
  suite?: Maybe<Scalars['String']['output']>;
};

export type ProductQuery = {
  __typename?: 'ProductQuery';
  findOne: Product;
  upsellProduct?: Maybe<UpsellProduct>;
};


export type ProductQueryFindOneArgs = {
  input: FindOneProductInput;
};


export type ProductQueryUpsellProductArgs = {
  input: GetRelatedProductInput;
};

export type ProductVariationOption = {
  __typename?: 'ProductVariationOption';
  name: Scalars['String']['output'];
  optionId: Scalars['String']['output'];
  values: Array<OptionValue>;
};

export type PromotionCollection = {
  __typename?: 'PromotionCollection';
  items: Array<PromotionGraphqlModel>;
  pagination: PaginationData;
};

export type PromotionCollectionResolver_GetPromotionCollection_BaseFilterInputType = {
  amount?: InputMaybe<Number_PropertyFilterInputType>;
  and?: InputMaybe<Array<PromotionCollectionResolver_GetPromotionCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  endDate?: InputMaybe<Date_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<PromotionCollectionResolver_GetPromotionCollection_BaseFilterInputType>>;
  productTypeCodes?: InputMaybe<String_PropertyFilterInputType>;
  startDate?: InputMaybe<Date_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type PromotionCollectionResolver_GetPromotionCollection_FilterInputType = {
  amount?: InputMaybe<Number_PropertyFilterInputType>;
  and?: InputMaybe<Array<PromotionCollectionResolver_GetPromotionCollection_BaseFilterInputType>>;
  code?: InputMaybe<String_PropertyFilterInputType>;
  endDate?: InputMaybe<Date_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<PromotionCollectionResolver_GetPromotionCollection_BaseFilterInputType>>;
  productTypeCodes?: InputMaybe<String_PropertyFilterInputType>;
  startDate?: InputMaybe<Date_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type PromotionCollectionResolver_GetPromotionCollection_SortingInputType = {
  amount?: InputMaybe<SortType>;
  code?: InputMaybe<SortType>;
  endDate?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  productTypeCodes?: InputMaybe<SortType>;
  startDate?: InputMaybe<SortType>;
  type?: InputMaybe<SortType>;
};

export type PromotionGraphqlModel = {
  __typename?: 'PromotionGraphqlModel';
  /** Amount of promotion */
  amount: Scalars['Float']['output'];
  /** Code of promotion */
  code: Scalars['String']['output'];
  /** End date of promotion */
  endDate: Scalars['DateTime']['output'];
  /** Name of promotion */
  name: Scalars['String']['output'];
  /** Product type codes of promotion */
  productTypeCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Start date of promotion */
  startDate: Scalars['DateTime']['output'];
  /** Type of promotion */
  type: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  VariationRelationshipCollection: VariationRelationshipCollection;
  bannerCollection: BannerCollection;
  canvas: CanvasQuery;
  cart: CartQuery;
  catalogProduct: CatalogProductQuery;
  catalogProductCollection: CatalogProductCollectionQuery;
  catalogProductCollectionCollection: CatalogProductCollectionCollection;
  catalogProductFormatCollection: CatalogProductFormatCollection;
  catalogProductGqlCollection: CatalogProductGraphqlCollection;
  catalogProductOptionType: CatalogProductOptionTypeQuery;
  catalogProductOptionTypeCollection: CatalogProductOptionTypeCollection;
  catalogProductOptionValue: CatalogProductOptionValueQuery;
  catalogProductOptionValueCollection: CatalogProductOptionValueCollection;
  catalogProductRelationship: CatalogProductRelationshipQuery;
  catalogProductSuiteCollection: CatalogProductSuiteCollection;
  catalogProductType: CatalogProductTypeQuery;
  catalogProductTypeCollection: CatalogProductTypeCollection;
  catalogProductVariation: CatalogProductVariationQuery;
  catalogProductVariationCollection: CatalogProductVariationCollection;
  draftCollection: CatalogProductDraftCollection;
  drafts: DraftsQuery;
  favorites: FavoritesQuery;
  menu: MenuGraphqlModel;
  order: OrderQuery;
  plpPage: PlpPageGraphqlModel;
  portfolioItem: PortfolioItemQuery;
  product: ProductQuery;
  promotionCollection: PromotionCollection;
  recentlyViewed: RecentlyViewedQuery;
  relatedCatalogProductVariations: CatalogProductVariationCollection;
  review: ReviewQuery;
};


export type QueryVariationRelationshipCollectionArgs = {
  filter?: InputMaybe<VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_SortingInputType>;
};


export type QueryBannerCollectionArgs = {
  filter?: InputMaybe<BannerCollectionResolver_GetBannerCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<BannerCollectionResolver_GetBannerCollection_SortingInputType>;
};


export type QueryCatalogProductCollectionCollectionArgs = {
  filter?: InputMaybe<CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductCollectionCollectionGraphqlResolver_GetCatalogProductCollectionCollection_SortingInputType>;
};


export type QueryCatalogProductFormatCollectionArgs = {
  filter?: InputMaybe<CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductFormatCollectionGraphqlResolver_GetCatalogProductFormatCollection_SortingInputType>;
};


export type QueryCatalogProductGqlCollectionArgs = {
  filter?: InputMaybe<CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductOptionTypeCollectionResolver_GetCatalogProductGqlCollection_SortingInputType>;
};


export type QueryCatalogProductOptionTypeCollectionArgs = {
  filter?: InputMaybe<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionTypeCollection_SortingInputType>;
};


export type QueryCatalogProductOptionValueCollectionArgs = {
  filter?: InputMaybe<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductOptionTypeCollectionResolver_GetCatalogProductOptionValueCollection_SortingInputType>;
};


export type QueryCatalogProductSuiteCollectionArgs = {
  filter?: InputMaybe<CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductSuiteCollectionGraphqlResolver_GetCatalogProductSuiteCollection_SortingInputType>;
};


export type QueryCatalogProductTypeCollectionArgs = {
  filter?: InputMaybe<CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductTypeCollectionGraphqlResolver_GetCatalogProductTypeCollection_SortingInputType>;
};


export type QueryCatalogProductVariationCollectionArgs = {
  filter?: InputMaybe<CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductVariationCollectionResolver_GetCatalogProductVariationCollection_SortingInputType>;
};


export type QueryDraftCollectionArgs = {
  filter?: InputMaybe<CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType>;
};


export type QueryMenuArgs = {
  filter?: InputMaybe<MenuFindOneResolver_FindOne_FilterInputType>;
};


export type QueryPlpPageArgs = {
  filter?: InputMaybe<CategoryPageResolver_FindByUrl_FilterInputType>;
};


export type QueryPromotionCollectionArgs = {
  filter?: InputMaybe<PromotionCollectionResolver_GetPromotionCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<PromotionCollectionResolver_GetPromotionCollection_SortingInputType>;
};


export type QueryRelatedCatalogProductVariationsArgs = {
  paginate?: InputMaybe<PaginatorInputArgs>;
  relationshipArgs: RelationshipGraphqlQueryArgs;
};

export type RecentlyViewedGraphqlModel = {
  __typename?: 'RecentlyViewedGraphqlModel';
  /** Date it was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Anonymous id */
  guestId?: Maybe<Scalars['String']['output']>;
  /** List of recently viewed items */
  items?: Maybe<Array<RecentlyViewedItemGraphqlModel>>;
  /** Last update */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Id of the registered user */
  userId?: Maybe<Scalars['String']['output']>;
};

export type RecentlyViewedItemGraphqlModel = {
  __typename?: 'RecentlyViewedItemGraphqlModel';
  /** Date it was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** item slug */
  slug: Scalars['String']['output'];
  /** Last update */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Variation id */
  variationId: Scalars['String']['output'];
};

export type RecentlyViewedMutation = {
  __typename?: 'RecentlyViewedMutation';
  upsertOne: RecentlyViewedGraphqlModel;
};


export type RecentlyViewedMutationUpsertOneArgs = {
  input: UpsertRecentlyViewedInput;
};

export type RecentlyViewedQuery = {
  __typename?: 'RecentlyViewedQuery';
  recentlyViewedCollection?: Maybe<Array<CatalogProductVariationGraphqlModel>>;
};

export type RelatedProduct = {
  __typename?: 'RelatedProduct';
  /** Index order of product offering. */
  index: Scalars['Float']['output'];
  /** Name of related product offering. */
  name: Scalars['String']['output'];
  /** ProductFormat of product offering. */
  productFormat?: Maybe<ProductFormat>;
  /** Slug of related product offering. */
  slug: Scalars['String']['output'];
  /** Type of related product offering. */
  type: ProductOption;
  /** Variations of related product offering. */
  variations: Array<RelatedProductVariation>;
};

export type RelatedProductVariation = {
  __typename?: 'RelatedProductVariation';
  /** Color of related product variation offering. */
  colorThemeSku?: Maybe<Scalars['String']['output']>;
  /** Flap type of related product variation offering. */
  flapTypeSku?: Maybe<Scalars['String']['output']>;
  /** Foil of related product variation offering. */
  foilThemeSku?: Maybe<Scalars['String']['output']>;
  optionValues?: Maybe<Array<OptionValue>>;
  /** Paper Color of related product variation offering. */
  paperColorSku?: Maybe<Scalars['String']['output']>;
  /** Paper Type of related product variation offering. */
  paperTypeSku?: Maybe<Scalars['String']['output']>;
  /** thumbnail of related product. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** VariationId for product variation offering. */
  variationId: Scalars['String']['output'];
};

export type RelatedVariation = {
  __typename?: 'RelatedVariation';
  /** Product Slug */
  slug: Scalars['String']['output'];
  /** Id of the variation */
  variationId: Scalars['String']['output'];
};

export type RelatedVariations = {
  __typename?: 'RelatedVariations';
  liner?: Maybe<RelatedVariation>;
  plainEnvelopeId?: Maybe<Scalars['String']['output']>;
  printedEnvelope?: Maybe<RelatedVariation>;
};

export type RelationshipAsFieldGraphqlQueryArgs = {
  /** The generic relationship */
  genericRelationship?: InputMaybe<Scalars['String']['input']>;
  /** The relationship type */
  relationshipType: Scalars['String']['input'];
};

export type RelationshipGraphqlQueryArgs = {
  /** The generic relationship */
  genericRelationship?: InputMaybe<Scalars['String']['input']>;
  /** The relationship type */
  relationshipType: Scalars['String']['input'];
  /** The variation id */
  variationId: Scalars['String']['input'];
};

export type RelationshipsTargetsGraphqlModel = {
  __typename?: 'RelationshipsTargetsGraphqlModel';
  /** Is the relationship generic */
  genericRelationship: Scalars['Boolean']['output'];
  /** The option value codes */
  optionValueCodes: Array<Scalars['String']['output']>;
  /** The order of the target */
  order: Scalars['Int']['output'];
  /** Parent product slug */
  productSlug: Scalars['String']['output'];
  /** The type of the relationship */
  relationshipType: Scalars['String']['output'];
  /** The variation */
  variation: CatalogProductVariationGraphqlModel;
  /** The id of the linked variation */
  variationId: Scalars['String']['output'];
};

export type RemoveFromCartInput = {
  /** item id array. */
  itemIds: Array<Scalars['String']['input']>;
};

export type ReorderAttributesInput = {
  /** The BigCommerce line item ID of the parent item (the item we are reordering) */
  originalLineItemId: Scalars['String']['input'];
  /** The BigCommerce order ID for the order containing the parent line item */
  originalOrderId: Scalars['Int']['input'];
  /** The reason code for ordering more of a product */
  reorderReasonCode: Scalars['Int']['input'];
};

export type Review = {
  __typename?: 'Review';
  /** Product display name */
  name: Scalars['String']['output'];
  /** Parent Product breadcrumb data */
  parentProductBreadcrumbs?: Maybe<ParentProductBreadcrumbs>;
  plainEnvelopeId?: Maybe<Scalars['String']['output']>;
  /** Portfolio data for review page */
  portfolioItem: PortfolioItem;
  price?: Maybe<VariationPrice>;
  /**
   * Product suite data for breadcrumb
   * @deprecated Please do not use this entities for new Development, use use CatalogProduct Models instead
   */
  productSuite: ProductOption;
  /** Product type data for breadcrumb */
  productType: ProductOption;
  /** Quantity of current product */
  quantity: Scalars['Float']['output'];
  /** Envelopes or liners url */
  relatedProductUrl?: Maybe<Scalars['String']['output']>;
  /** Product Slug */
  slug: Scalars['String']['output'];
  /** VariationId of current product */
  variationId: Scalars['String']['output'];
};

export type ReviewPortfolio = {
  __typename?: 'ReviewPortfolio';
  /** Portfolio data for review page */
  portfolioItem: PortfolioItem;
  price?: Maybe<VariationPrice>;
  /**
   * Product data
   * @deprecated Please do not use this entities for new Development, use CatalogProduct Models instead
   */
  product: ReviewProduct;
  upsellProduct?: Maybe<ReviewUpsellProduct>;
  /**
   * Variation of Portfolio Review
   * @deprecated Please do not use this entities for new Development, use CatalogProduct Models instead
   */
  variation: Variation;
};

export type ReviewProduct = {
  __typename?: 'ReviewProduct';
  /**
   * Name of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * options variants of product.
   * @deprecated ProductVariationOptions (variationOptions field) instead
   */
  options: ProductOptions;
  /**
   * Slug of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
  /**
   * suite info of product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  suite: Suite;
  /**
   * type info of product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  type: ProductOption;
  /**
   * Option values associated with the product.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  variationOptions?: Maybe<Array<ProductVariationOption>>;
};

export type ReviewQuery = {
  __typename?: 'ReviewQuery';
  findOne: Review;
  findOneByPortfolio?: Maybe<ReviewPortfolio>;
};


export type ReviewQueryFindOneArgs = {
  id: Scalars['String']['input'];
};


export type ReviewQueryFindOneByPortfolioArgs = {
  portfolioItemId: Scalars['String']['input'];
};

export type ReviewUpsellProduct = {
  __typename?: 'ReviewUpsellProduct';
  /** Front Image of Related Product */
  image: Scalars['String']['output'];
  /** Related Product name */
  name: Scalars['String']['output'];
  /**
   * Prices for product variation
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation.priceTiers instead
   */
  price?: Maybe<VariationPrice>;
  /** Related Product slug */
  slug: Scalars['String']['output'];
  suite: Suite;
  type: ProductOption;
  /** @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead */
  variation: Variation;
};

export type SessionMutation = {
  __typename?: 'SessionMutation';
  refresh?: Maybe<SessionResult>;
};

export type SessionResult = {
  __typename?: 'SessionResult';
  /** Whether the refresh resulted in the user's member and guest carts being combined. */
  cartMerge: Scalars['Boolean']['output'];
  /** Status of session */
  status: Scalars['String']['output'];
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  /** The city of the recipient. */
  city: Scalars['String']['output'];
  /** The country of the recipient. */
  country: Scalars['String']['output'];
  /** The first name of the recipient. */
  firstName: Scalars['String']['output'];
  /** The last name of the recipient. */
  lastName: Scalars['String']['output'];
  /** The phone number associated with the address. */
  phone: Scalars['String']['output'];
  /** The shipping method associated with this address. */
  shippingMethod: Scalars['String']['output'];
  /** The state of the recipient. */
  state: Scalars['String']['output'];
  /** The street address line 1 of the recipient. */
  street: Scalars['String']['output'];
  /** The street address line 2 of the recipient. */
  street2: Scalars['String']['output'];
  /** The zip code of the recipient. */
  zipCode: Scalars['String']['output'];
};

export type SingleItemCartResult = {
  __typename?: 'SingleItemCartResult';
  /** Updated cart */
  cart?: Maybe<CartDetails>;
  /** Updated item */
  item?: Maybe<CartDetailsItem>;
};

export type Size = {
  __typename?: 'Size';
  /**
   * Height of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  height: Scalars['Float']['output'];
  /**
   * Width of product offering.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  width: Scalars['Float']['output'];
};

export enum SortType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type String_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notbetween?: InputMaybe<Array<Scalars['String']['input']>>;
  notin?: InputMaybe<Array<Scalars['String']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Suite = {
  __typename?: 'Suite';
  /**
   * Suite collection
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  collection?: Maybe<ProductCollection>;
  /**
   * Default product options for the suite.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  defaultOptions?: Maybe<DefaultProductOptions>;
  /**
   * Should the Product Detail Pages be hidden on the frontend
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  hideProductDetailPages?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Name of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * Sku of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  sku: Scalars['String']['output'];
  /**
   * Slug of product option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
  /**
   * Styles for the suite.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  styles?: Maybe<Array<Scalars['String']['output']>>;
};

export type TemplateConfiguration = {
  __typename?: 'TemplateConfiguration';
  /** Design editor markup associated with the product that has fold lines or spine lines. */
  designEditorMarkup?: Maybe<CatalogDesignEditorMarkupGraphqlModel>;
  /** Whether to hide the back surface of the template */
  hideBackSurface: Scalars['Boolean']['output'];
  /** Whether to hide the front surface of the template */
  hideFrontSurface: Scalars['Boolean']['output'];
};

/** The status of the template */
export enum TemplateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum Tenant {
  Test = 'TEST',
  Tk = 'TK',
  Ww = 'WW'
}

export type UpdateCartItem = {
  /** Id of the cart item. */
  id: Scalars['String']['input'];
  /** Quantity of item. */
  quantity: Scalars['Int']['input'];
};

export type UpdateCartItemInput = {
  /** Cart items. */
  items: Array<UpdateCartItem>;
};

export type UpdatePortfolioItemInput = {
  customizer?: InputMaybe<CustomizerInput>;
  id: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The option value ids that have been selected, used to calculate variation changes. */
  selectedProductOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  urlPrintOverride?: InputMaybe<Scalars['String']['input']>;
  variationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsellProduct = {
  __typename?: 'UpsellProduct';
  /**
   * Front Image of Related Product
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  image: Scalars['String']['output'];
  /**
   * Related Product name
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  name: Scalars['String']['output'];
  /**
   * Related Product slug
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  slug: Scalars['String']['output'];
  /** @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead */
  suite: Suite;
  /** @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead */
  type: ProductOption;
  /** @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead */
  variation: Variation;
};

export type UpsertItemToDraftsInput = {
  /** Parent ID of group. */
  draftGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the draft item. */
  id: Scalars['String']['input'];
  /** Parent item id of the draft */
  parentItemId?: InputMaybe<Scalars['String']['input']>;
  /** PortfolioItem to create and associate */
  portfolioItem?: InputMaybe<Scalars['UUID']['input']>;
  /** The selected product quantity. */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Last update time */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpsertRecentlyViewedInput = {
  /** slug */
  slug: Scalars['String']['input'];
  /** id of the variation */
  variationId: Scalars['String']['input'];
};

export type UrlProofInput = {
  position: Scalars['Float']['input'];
  url: Scalars['String']['input'];
};

export type Variation = {
  __typename?: 'Variation';
  /** Id of the product in the CMS. */
  catalogProductId: Scalars['String']['output'];
  /**
   * SKU code identifying the color theme.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  colorThemeCode: Scalars['String']['output'];
  /**
   * Name associated with the colorThemeCode.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  colorThemeName?: Maybe<Scalars['String']['output']>;
  /**
   * SKU code identifying the envelope printing option.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  envelopePrintingOptionCode?: Maybe<Scalars['String']['output']>;
  /**
   * Name associated with the envelopePrintingOptionCode.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  envelopePrintingOptionName?: Maybe<Scalars['String']['output']>;
  /**
   * SKU code identifying the flap type of the variant.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  flapTypeCode?: Maybe<Scalars['String']['output']>;
  /**
   * SKU code identifying the foil color.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  foilCode?: Maybe<Scalars['String']['output']>;
  /**
   * Name associated with the foilCode.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  foilName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Whether this is a sample variation. */
  isSample: Scalars['Boolean']['output'];
  /** @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead */
  optionValues?: Maybe<Array<OptionValue>>;
  /**
   * SKU code identifying the paper color of the variant.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  paperColorCode?: Maybe<Scalars['String']['output']>;
  /**
   * SKU code identifying the paper type.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  paperTypeCode?: Maybe<Scalars['String']['output']>;
  /**
   * Name associated with the paperTypeCode.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  paperTypeName?: Maybe<Scalars['String']['output']>;
  product: Product;
  /** SKU code identifying the product type. */
  productCode: Scalars['String']['output'];
  /** SKU code identifying the suite. */
  suiteCode: Scalars['String']['output'];
  /** Brand identifier. */
  tenant: Tenant;
  /**
   * Customizer Files associated with the variation.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  variationCustomizerFiles: Array<VariationCustomizerFile>;
  /**
   * Images associated with the variation.
   * @deprecated Please do not use this entities for new Development, use CatalogProductVariation instead
   */
  variationImages: Array<VariationImage>;
};

export type VariationCanvas = {
  __typename?: 'VariationCanvas';
  /** Configuration for initializing a variation-based customization. */
  canvasInitialization?: Maybe<CanvasInitialization>;
  /** Configuration for initializing a product-based customization. */
  canvasInitializationByProduct?: Maybe<CanvasInitializationByProduct>;
  /**
   * Product display name
   * @deprecated Use portfolioItem.catalogProductVariation.catalogProduct.name instead
   */
  name: Scalars['String']['output'];
  /**
   * Represents the unique combination of options selected for the product.
   * @deprecated Use portfolioItem.catalogProductVariation instead
   */
  variation: Variation;
};

export type VariationCustomizerFile = {
  __typename?: 'VariationCustomizerFile';
  /** Product Id */
  catalogProductId: Scalars['String']['output'];
  /** Design file url */
  designFileUrl: Scalars['String']['output'];
  /** Option Values */
  optionValues: Scalars['String']['output'];
  /** The type of design (back, front, mockup). */
  tag: Scalars['String']['output'];
};

export type VariationCustomizerFileGraphqlModel = {
  __typename?: 'VariationCustomizerFileGraphqlModel';
  /** The role of the customizer file */
  role: Scalars['String']['output'];
  /** The url of the customizer file */
  url: Scalars['String']['output'];
};

export type VariationDisplayProductOptionGraphqlModel = {
  __typename?: 'VariationDisplayProductOptionGraphqlModel';
  /** The name of the option */
  name: Scalars['String']['output'];
  /** The id of the option */
  optionId: Scalars['String']['output'];
  /** The values of the option */
  values: Array<VariationDisplayProductOptionValueGraphqlModel>;
};

export type VariationDisplayProductOptionValueGraphqlModel = {
  __typename?: 'VariationDisplayProductOptionValueGraphqlModel';
  /** Background Color/Image URL */
  background?: Maybe<Scalars['String']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicate Forbidden state */
  forbidden: Scalars['Boolean']['output'];
  /** Icon URL */
  iconUrl?: Maybe<Scalars['String']['output']>;
  instructions: Array<Scalars['JSON']['output']>;
  /** The name of the option value */
  name: Scalars['String']['output'];
  /** the Code of the Option Type */
  optionId: Scalars['String']['output'];
  /** Indicate if value is offered as sample */
  sample: Scalars['Boolean']['output'];
  /** Indicate Selected state */
  selected: Scalars['Boolean']['output'];
  /** The Slug of the option value */
  slug: Scalars['String']['output'];
  /** The Code of the Option Value */
  valueId: Scalars['String']['output'];
};


export type VariationDisplayProductOptionValueGraphqlModelInstructionsArgs = {
  input?: InputMaybe<InstructionsInput>;
};

export type VariationFlatProductOptionValueGraphqlModel = {
  __typename?: 'VariationFlatProductOptionValueGraphqlModel';
  /** The name of the option value */
  name: Scalars['String']['output'];
  /** The id of the option */
  optionId: Scalars['String']['output'];
  /** The value of the option */
  valueId: Scalars['String']['output'];
};

export type VariationFriendlyPriceTierGraphqlModel = {
  __typename?: 'VariationFriendlyPriceTierGraphqlModel';
  /** The quantity reference of the price tier */
  priceTierReference: Scalars['String']['output'];
  /** The amount of the price tier */
  quantity: Scalars['Float']['output'];
  /** Price for all units (quantity * unitAmount) */
  totalAmount: Scalars['Float']['output'];
  /** Price for individual units */
  unitAmount: Scalars['Float']['output'];
};

export type VariationImage = {
  __typename?: 'VariationImage';
  /** Id of the product in the catalog. */
  catalogProductId: Scalars['String']['output'];
  /** The url of the variation image. */
  imageUrl: Scalars['String']['output'];
  optionValues?: Maybe<Array<OptionValue>>;
  /** The type of image (back, front, hero, etc). */
  tag: Scalars['String']['output'];
};

export type VariationImageGraphqlModel = {
  __typename?: 'VariationImageGraphqlModel';
  /** The order of the image */
  order: Scalars['Float']['output'];
  /** The role of the image */
  role: Scalars['String']['output'];
  /** The url of the image */
  url: Scalars['String']['output'];
};

export type VariationPrice = {
  __typename?: 'VariationPrice';
  /**
   * base Price of related product variation.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  basePrice: Scalars['Float']['output'];
  /**
   * Bulk Prices of related product variation.
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  bulkPrices?: Maybe<Array<BulkPrice>>;
  /**
   * Price modifier for product variation price display
   * @deprecated Please do not use this entities for new Development, use CatalogProductAPI instead
   */
  priceModifiers?: Maybe<Array<PriceModifier>>;
};

export type VariationPriceModifierGraphqlModel = {
  __typename?: 'VariationPriceModifierGraphqlModel';
  /** The amount of the price modifier */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The id of the option */
  optionId: Scalars['String']['output'];
  /** The type of the price modifier */
  priceModifierType: Scalars['String']['output'];
  /** The currency of the price modifier */
  priceTier?: Maybe<Array<VariationPriceTierGraphqlModel>>;
  /** The id of the price modifier */
  valueId: Scalars['String']['output'];
};

export type VariationPriceTierGraphqlModel = {
  __typename?: 'VariationPriceTierGraphqlModel';
  /** The amount of the price tier */
  amount: Scalars['Float']['output'];
  /** The maximum quantity of the price tier */
  max?: Maybe<Scalars['Float']['output']>;
  /** The minimum quantity of the price tier */
  min?: Maybe<Scalars['Float']['output']>;
  /** The quantity reference of the price tier */
  priceTierReference: Scalars['String']['output'];
};

export type VariationRelationshipCollection = {
  __typename?: 'VariationRelationshipCollection';
  items: Array<VariationRelationshipGraphqlModel>;
  pagination: PaginationData;
};

export type VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_BaseFilterInputType = {
  _id?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_BaseFilterInputType>>;
  optionValueCodes?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_BaseFilterInputType>>;
  productSlug?: InputMaybe<String_PropertyFilterInputType>;
  variationId?: InputMaybe<String_PropertyFilterInputType>;
};

export type VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_FilterInputType = {
  _id?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_BaseFilterInputType>>;
  optionValueCodes?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_BaseFilterInputType>>;
  productSlug?: InputMaybe<String_PropertyFilterInputType>;
  variationId?: InputMaybe<String_PropertyFilterInputType>;
};

export type VariationRelationshipCollectionResolver_GetVariationRelationshipCollection_SortingInputType = {
  _id?: InputMaybe<SortType>;
  optionValueCodes?: InputMaybe<SortType>;
  productSlug?: InputMaybe<SortType>;
  variationId?: InputMaybe<SortType>;
};

export type VariationRelationshipGraphqlModel = {
  __typename?: 'VariationRelationshipGraphqlModel';
  /** The id of the relationship */
  _id: Scalars['String']['output'];
  /** The option value codes */
  optionValueCodes: Array<Scalars['String']['output']>;
  /** Parent product slug */
  productSlug: Scalars['String']['output'];
  /** The targets of the relationship */
  targets: Array<RelationshipsTargetsGraphqlModel>;
  /** The id of the source variation */
  variationId: Scalars['String']['output'];
};

export type UrlProof = {
  __typename?: 'urlProof';
  /** Zero-based list representing proof image position. */
  position: Scalars['Int']['output'];
  /** URL to image of the design proof that should be used for display. */
  url: Scalars['String']['output'];
};

export type VariationFragment = { __typename?: 'CartDetailsItem', variation?: { __typename?: 'CatalogProductVariationGraphqlModel', id: string, isSample: boolean, catalogProductTypeCode: string, images: Array<{ __typename?: 'VariationImageGraphqlModel', url: string, role: string }>, priceTiers: Array<{ __typename?: 'VariationFriendlyPriceTierGraphqlModel', quantity: number, totalAmount: number }>, optionValues: Array<{ __typename?: 'VariationFlatProductOptionValueGraphqlModel', optionId: string, valueId: string, name: string }>, catalogProduct: { __typename?: 'CatalogProductGraphqlModel', name: string, slug: string } } | null };

export type PortfolioFragment = { __typename?: 'CartDetailsItem', portfolio?: { __typename?: 'PortfolioItem', id: string, customizer?: { __typename?: 'Customizer', urlProofs: Array<{ __typename?: 'urlProof', url: string }> } | null } | null };

export type AccessoriesFragment = { __typename?: 'CartDetailsItem', accessories?: { __typename?: 'ItemAccessories', liner?: { __typename?: 'CatalogProductVariationGraphqlModel', catalogProductSlug: string, id: string, catalogProduct: { __typename?: 'CatalogProductGraphqlModel', name: string }, images: Array<{ __typename?: 'VariationImageGraphqlModel', role: string, url: string }> } | null, plainEnvelope?: { __typename?: 'CatalogProductVariationGraphqlModel', catalogProductSlug: string, id: string } | null, printedEnvelope?: { __typename?: 'CatalogProductVariationGraphqlModel', catalogProductSlug: string, id: string, catalogProduct: { __typename?: 'CatalogProductGraphqlModel', name: string }, images: Array<{ __typename?: 'VariationImageGraphqlModel', role: string, url: string }> } | null } | null };

export type GetCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartQuery = { __typename?: 'Query', cart: { __typename?: 'CartQuery', details?: { __typename?: 'CartDetails', storeCartId: string, items: Array<{ __typename?: 'CartDetailsItem', id: string, quantity: number, totalAmount: number, parentId?: string | null, productTypeName: string, portfolio?: { __typename?: 'PortfolioItem', id: string, customizer?: { __typename?: 'Customizer', urlProofs: Array<{ __typename?: 'urlProof', url: string }> } | null } | null, variation?: { __typename?: 'CatalogProductVariationGraphqlModel', id: string, isSample: boolean, catalogProductTypeCode: string, images: Array<{ __typename?: 'VariationImageGraphqlModel', url: string, role: string }>, priceTiers: Array<{ __typename?: 'VariationFriendlyPriceTierGraphqlModel', quantity: number, totalAmount: number }>, optionValues: Array<{ __typename?: 'VariationFlatProductOptionValueGraphqlModel', optionId: string, valueId: string, name: string }>, catalogProduct: { __typename?: 'CatalogProductGraphqlModel', name: string, slug: string } } | null, accessories?: { __typename?: 'ItemAccessories', liner?: { __typename?: 'CatalogProductVariationGraphqlModel', catalogProductSlug: string, id: string, catalogProduct: { __typename?: 'CatalogProductGraphqlModel', name: string }, images: Array<{ __typename?: 'VariationImageGraphqlModel', role: string, url: string }> } | null, plainEnvelope?: { __typename?: 'CatalogProductVariationGraphqlModel', catalogProductSlug: string, id: string } | null, printedEnvelope?: { __typename?: 'CatalogProductVariationGraphqlModel', catalogProductSlug: string, id: string, catalogProduct: { __typename?: 'CatalogProductGraphqlModel', name: string }, images: Array<{ __typename?: 'VariationImageGraphqlModel', role: string, url: string }> } | null } | null }> } | null } };

export type GetPromotionsQueryVariables = Exact<{
  filter?: InputMaybe<PromotionCollectionResolver_GetPromotionCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<PromotionCollectionResolver_GetPromotionCollection_SortingInputType>;
}>;


export type GetPromotionsQuery = { __typename?: 'Query', promotionCollection: { __typename?: 'PromotionCollection', items: Array<{ __typename?: 'PromotionGraphqlModel', amount: number, code: string, endDate: any, name: string, productTypeCodes?: Array<string> | null, startDate: any, type: string }>, pagination: { __typename?: 'PaginationData', page: number, perPage: number, total: number } } };

export type GetMenuQueryVariables = Exact<{
  menuCode: Scalars['String']['input'];
}>;


export type GetMenuQuery = { __typename?: 'Query', menu: { __typename?: 'MenuGraphqlModel', code: string, name: string, treeStructure: any } };

export type PaginationFragment = { __typename?: 'PaginationData', page: number, perPage: number, total: number };

export type GetDraftsCountQueryVariables = Exact<{
  filter?: InputMaybe<CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType>;
}>;


export type GetDraftsCountQuery = { __typename?: 'Query', draftCollection: { __typename?: 'CatalogProductDraftCollection', items: Array<{ __typename?: 'CatalogDraftsGraphqlModel', portfolioItem: { __typename?: 'PortfolioItem', isCustomized: boolean } }>, pagination: { __typename?: 'PaginationData', page: number, perPage: number, total: number } } };

export type GetAllDraftsQueryVariables = Exact<{
  filter?: InputMaybe<CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType>;
  paginate?: InputMaybe<PaginatorInputArgs>;
  sort?: InputMaybe<CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType>;
}>;


export type GetAllDraftsQuery = { __typename?: 'Query', draftCollection: { __typename?: 'CatalogProductDraftCollection', items: Array<{ __typename?: 'CatalogDraftsGraphqlModel', id: string, draftGroupId: string, image: string, price: number, quantity: number, userId: string, updatedAt: any, portfolioItem: { __typename?: 'PortfolioItem', id: string, memberId?: string | null, notes?: string | null, tenant: Tenant, isCustomized: boolean, customizer?: { __typename?: 'Customizer', stateId: string, urlPrint: string, userId: string, urlProofs: Array<{ __typename?: 'urlProof', position: number, url: string }> } | null }, variation: { __typename?: 'CatalogProductVariationGraphqlModel', id: string, catalogProductSuiteCode: string, isSample: boolean, catalogProduct: { __typename?: 'CatalogProductGraphqlModel', externalId: string, catalogProductTypeCode: string, name: string, slug: string, catalogProductType: { __typename?: 'CatalogProductTypeGraphqlModel', name: string } }, images: Array<{ __typename?: 'VariationImageGraphqlModel', url: string, order: number, role: string }>, optionValues: Array<{ __typename?: 'VariationFlatProductOptionValueGraphqlModel', name: string, optionId: string, valueId: string }> } }>, pagination: { __typename?: 'PaginationData', page: number, perPage: number, total: number } } };

export type GetProductDetailQueryVariables = Exact<{
  input: FindOneProductInput;
}>;


export type GetProductDetailQuery = { __typename?: 'Query', product: { __typename?: 'ProductQuery', findOne: { __typename?: 'Product', name: string, description?: string | null, slug: string, catalogProductId: string, variations: string, isLive: boolean, summary?: string | null, suite: { __typename?: 'Suite', name: string, sku: string, slug: string, hideProductDetailPages?: boolean | null, collection?: { __typename?: 'ProductCollection', name: string, title: string, slug: string, isInBadge?: boolean | null, isInTitle?: boolean | null, isInBreadcrumbs?: boolean | null, isInMatchingSuites?: boolean | null, color?: string | null, imageUrl?: string | null } | null }, type: { __typename?: 'ProductOption', name: string, sku: string, slug: string }, category?: { __typename?: 'Category', name: string, slug: string } | null, displayOptions?: { __typename?: 'ProductDisplayOptions', designedBy?: string | null, size: { __typename?: 'Size', height: number, width: number } } | null, relatedProducts?: Array<{ __typename?: 'RelatedProduct', index: number, name: string, slug: string, format?: { __typename?: 'ProductFormat', sku: string, name: string } | null, variations: Array<{ __typename?: 'RelatedProductVariation', colorThemeSku?: string | null, flapTypeSku?: string | null, foilThemeSku?: string | null, paperColorSku?: string | null, paperTypeSku?: string | null, thumbnail?: string | null, variationId: string, optionValues?: Array<{ __typename?: 'OptionValue', optionId: string, valueId: string, name: string }> | null }>, type: { __typename?: 'ProductOption', sku: string, name: string, slug: string } }> | null, options: { __typename?: 'ProductOptions', colors?: Array<{ __typename?: 'Colors', colorHex: string, name: string, slug: string, sku: string }> | null }, productOptions?: Array<{ __typename?: 'ProductVariationOption', name: string, optionId: string, values: Array<{ __typename?: 'OptionValue', optionId: string, valueId: string, name: string }> }> | null, selectedVariant?: { __typename?: 'ProductOptionsSkus', colorThemeCode?: string | null, envelopePrintingOptionCode?: string | null, foilCode?: string | null, paperTypeCode?: string | null, paperColorCode?: string | null, flapTypeCode?: string | null } | null, foilSampleVariation?: { __typename?: 'FoilSampleVariation', variationId?: string | null, foilTheme?: string | null, paperType?: string | null, colorTheme?: string | null } | null, productTypeSiblings?: Array<{ __typename?: 'ProductFormatDetails', name: string, iconUrl: string, priceNotation: string, sizeShortText: string, sku: string, slug: string }> | null, productFormat: { __typename?: 'ProductFormat', name: string, iconUrl: string, priceNotation: string, sizeShortText: string, sku: string } } } };

export type AddToDraftMutationVariables = Exact<{
  input: InitCanvasInput;
}>;


export type AddToDraftMutation = { __typename?: 'Mutation', canvas: { __typename?: 'CanvasMutation', initCanvas: { __typename?: 'InitCanvasResult', id: string, draftId: string } } };

export type AddToCartMutationVariables = Exact<{
  input: AddItemToCartInput;
}>;


export type AddToCartMutation = { __typename?: 'Mutation', cart: { __typename?: 'CartMutation', addItem?: { __typename?: 'SingleItemCartResult', item?: { __typename?: 'CartDetailsItem', portfolioItem?: { __typename?: 'PortfolioItem', id: string } | null } | null } | null } };

export type AddItemToCartMutationVariables = Exact<{
  input: AddItemToCartInput;
}>;


export type AddItemToCartMutation = { __typename?: 'Mutation', cart: { __typename?: 'CartMutation', addItem?: { __typename?: 'SingleItemCartResult', cart?: { __typename?: 'CartDetails', storeCartId: string } | null, item?: { __typename?: 'CartDetailsItem', portfolioItem?: { __typename?: 'PortfolioItem', id: string } | null } | null } | null } };

export type GetAccessoriesQueryVariables = Exact<{
  input: FindOneProductInput;
}>;


export type GetAccessoriesQuery = { __typename?: 'Query', product: { __typename?: 'ProductQuery', findOne: { __typename?: 'Product', suite: { __typename?: 'Suite', name: string, sku: string, slug: string, collection?: { __typename?: 'ProductCollection', name: string, title: string, slug: string, isInBadge?: boolean | null, isInTitle?: boolean | null, isInBreadcrumbs?: boolean | null, isInMatchingSuites?: boolean | null, color?: string | null, imageUrl?: string | null } | null }, selectedVariant?: { __typename?: 'ProductOptionsSkus', colorThemeCode?: string | null, foilCode?: string | null, envelopePrintingOptionCode?: string | null, paperTypeCode?: string | null, paperColorCode?: string | null } | null, relatedProducts?: Array<{ __typename?: 'RelatedProduct', index: number, name: string, slug: string, format?: { __typename?: 'ProductFormat', sku: string, name: string } | null, variations: Array<{ __typename?: 'RelatedProductVariation', colorThemeSku?: string | null, flapTypeSku?: string | null, foilThemeSku?: string | null, paperColorSku?: string | null, paperTypeSku?: string | null, thumbnail?: string | null, variationId: string, optionValues?: Array<{ __typename?: 'OptionValue', optionId: string, valueId: string, name: string }> | null }>, type: { __typename?: 'ProductOption', sku: string, name: string, slug: string } }> | null } } };

export const VariationFragmentDoc = gql`
    fragment Variation on CartDetailsItem {
  variation: displayVariation {
    id
    isSample
    catalogProductTypeCode
    images {
      url
      role
    }
    priceTiers: friendlyPriceTiers {
      quantity
      totalAmount
    }
    optionValues {
      optionId
      valueId
      name
    }
    catalogProduct {
      name
      slug
    }
  }
}
    `;
export const PortfolioFragmentDoc = gql`
    fragment Portfolio on CartDetailsItem {
  portfolio: portfolioItem {
    id
    customizer {
      urlProofs {
        url
      }
    }
  }
}
    `;
export const AccessoriesFragmentDoc = gql`
    fragment Accessories on CartDetailsItem {
  accessories {
    liner {
      catalogProductSlug
      id
      catalogProduct {
        name
      }
      images(input: {role: {equal: "front"}}) {
        role
        url
      }
    }
    plainEnvelope {
      catalogProductSlug
      id
    }
    printedEnvelope {
      catalogProductSlug
      id
      catalogProduct {
        name
      }
      images(input: {role: {equal: "front"}}) {
        role
        url
      }
    }
  }
}
    `;
export const PaginationFragmentDoc = gql`
    fragment Pagination on PaginationData {
  page
  perPage
  total
}
    `;
export const GetCartDocument = gql`
    query getCart {
  cart {
    details {
      storeCartId
      items {
        id
        quantity
        totalAmount
        parentId
        productTypeName
        ...Portfolio
        ...Variation
        ...Accessories
      }
    }
  }
}
    ${PortfolioFragmentDoc}
${VariationFragmentDoc}
${AccessoriesFragmentDoc}`;
export const GetPromotionsDocument = gql`
    query getPromotions($filter: PromotionCollectionResolver_GetPromotionCollection_FilterInputType, $paginate: PaginatorInputArgs, $sort: PromotionCollectionResolver_GetPromotionCollection_SortingInputType) {
  promotionCollection(filter: $filter, paginate: $paginate, sort: $sort) {
    items {
      amount
      code
      endDate
      name
      productTypeCodes
      startDate
      type
    }
    pagination {
      page
      perPage
      total
    }
  }
}
    `;
export const GetMenuDocument = gql`
    query getMenu($menuCode: String!) {
  menu(filter: {code: {eq: $menuCode}}) {
    code
    name
    treeStructure
  }
}
    `;
export const GetDraftsCountDocument = gql`
    query getDraftsCount($filter: CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType, $paginate: PaginatorInputArgs, $sort: CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType) {
  draftCollection(filter: $filter, paginate: $paginate, sort: $sort) {
    items {
      portfolioItem {
        isCustomized
      }
    }
    pagination {
      ...Pagination
    }
  }
}
    ${PaginationFragmentDoc}`;
export const GetAllDraftsDocument = gql`
    query getAllDrafts($filter: CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType, $paginate: PaginatorInputArgs, $sort: CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType) {
  draftCollection(filter: $filter, paginate: $paginate, sort: $sort) {
    items {
      id
      draftGroupId
      image
      price
      quantity
      userId
      updatedAt
      portfolioItem {
        id
        memberId
        notes
        tenant
        customizer {
          stateId
          urlPrint
          urlProofs {
            position
            url
          }
          userId
        }
        isCustomized
      }
      variation {
        id
        catalogProduct {
          externalId
          catalogProductTypeCode
          name
          slug
          catalogProductType {
            name
          }
        }
        catalogProductSuiteCode
        images {
          url
          order
          role
        }
        optionValues {
          name
          optionId
          valueId
        }
        isSample
      }
    }
    pagination {
      ...Pagination
    }
  }
}
    ${PaginationFragmentDoc}`;
export const GetProductDetailDocument = gql`
    query getProductDetail($input: FindOneProductInput!) {
  product {
    findOne(input: $input) {
      name
      description
      slug
      catalogProductId
      variations
      isLive
      suite {
        name
        sku
        slug
        collection {
          name
          title
          slug
          isInBadge
          isInTitle
          isInBreadcrumbs
          isInMatchingSuites
          color
          imageUrl
        }
        hideProductDetailPages
      }
      type {
        name
        sku
        slug
      }
      category {
        name
        slug
      }
      displayOptions {
        designedBy
        size {
          height
          width
        }
      }
      relatedProducts {
        index
        name
        slug
        format: productFormat {
          sku
          name
        }
        variations {
          colorThemeSku
          flapTypeSku
          foilThemeSku
          paperColorSku
          paperTypeSku
          thumbnail
          variationId
          optionValues {
            optionId
            valueId
            name
          }
        }
        type {
          sku
          name
          slug
        }
      }
      options {
        colors {
          colorHex
          name
          slug
          sku
        }
      }
      productOptions: variationOptions {
        name
        optionId
        values {
          optionId
          valueId
          name
        }
      }
      summary
      isLive
      selectedVariant {
        colorThemeCode
        envelopePrintingOptionCode
        foilCode
        paperTypeCode
        paperColorCode
        flapTypeCode
      }
      foilSampleVariation {
        variationId
        foilTheme
        paperType
        colorTheme
      }
      productTypeSiblings {
        name
        iconUrl
        priceNotation
        sizeShortText
        sku
        slug
      }
      productFormat {
        name
        iconUrl
        priceNotation
        sizeShortText
        sku
      }
    }
  }
}
    `;
export const AddToDraftDocument = gql`
    mutation addToDraft($input: InitCanvasInput!) {
  canvas {
    initCanvas(input: $input) {
      id
      draftId
    }
  }
}
    `;
export const AddToCartDocument = gql`
    mutation addToCart($input: AddItemToCartInput!) {
  cart {
    addItem(input: $input) {
      item {
        portfolioItem {
          id
        }
      }
    }
  }
}
    `;
export const AddItemToCartDocument = gql`
    mutation addItemToCart($input: AddItemToCartInput!) {
  cart {
    addItem(input: $input) {
      cart {
        storeCartId
      }
      item {
        portfolioItem {
          id
        }
      }
    }
  }
}
    `;
export const GetAccessoriesDocument = gql`
    query getAccessories($input: FindOneProductInput!) {
  product {
    findOne(input: $input) {
      suite {
        name
        sku
        slug
        collection {
          name
          title
          slug
          isInBadge
          isInTitle
          isInBreadcrumbs
          isInMatchingSuites
          color
          imageUrl
        }
      }
      selectedVariant {
        colorThemeCode
        foilCode
        colorThemeCode
        envelopePrintingOptionCode
        paperTypeCode
        paperColorCode
      }
      relatedProducts {
        index
        name
        slug
        format: productFormat {
          sku
          name
        }
        variations {
          colorThemeSku
          flapTypeSku
          foilThemeSku
          paperColorSku
          paperTypeSku
          thumbnail
          variationId
          optionValues {
            optionId
            valueId
            name
          }
        }
        type {
          sku
          name
          slug
        }
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getCart(variables?: GetCartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCartQuery>(GetCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCart', 'query', variables);
    },
    getPromotions(variables?: GetPromotionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPromotionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPromotionsQuery>(GetPromotionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPromotions', 'query', variables);
    },
    getMenu(variables: GetMenuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMenuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMenuQuery>(GetMenuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMenu', 'query', variables);
    },
    getDraftsCount(variables?: GetDraftsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDraftsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDraftsCountQuery>(GetDraftsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDraftsCount', 'query', variables);
    },
    getAllDrafts(variables?: GetAllDraftsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllDraftsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllDraftsQuery>(GetAllDraftsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllDrafts', 'query', variables);
    },
    getProductDetail(variables: GetProductDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductDetailQuery>(GetProductDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProductDetail', 'query', variables);
    },
    addToDraft(variables: AddToDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddToDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddToDraftMutation>(AddToDraftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addToDraft', 'mutation', variables);
    },
    addToCart(variables: AddToCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddToCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddToCartMutation>(AddToCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addToCart', 'mutation', variables);
    },
    addItemToCart(variables: AddItemToCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddItemToCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddItemToCartMutation>(AddItemToCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addItemToCart', 'mutation', variables);
    },
    getAccessories(variables: GetAccessoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAccessoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAccessoriesQuery>(GetAccessoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAccessories', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;